(function () {
    const de = document.documentElement.lang.indexOf("de") >= 0;

    const overlay = $(".quick-help-overlay");
    const chatBox = overlay.find("> div > section");
    const messageList = overlay.find("> div > section > div");
    let entryCallback = null;

    const MAX_FILE_SIZE = 10;

    let daysOfWeek, months;


    if (de) {
        daysOfWeek = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
        months = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
    } else {
        daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wedesday", "Thursday", "Friday", "Saturday"];
        months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    }

    function zeroPad(value) {
        return ("00" + value).substr(-2);
    }

    function prettyDate(date, includeTime = true) {
        if (!date) {
            return _t("Never", "Nie");
        } else {
            const now = new Date().getTime();
            let delta = parseInt((now - date.getTime()) / 1000);
            let isInTheFuture = delta < 0;

            let prefix = "";
            let suffix = " ago";

            if (de) {
                prefix = "vor ";
                suffix = "";
            }

            if (isInTheFuture) {
                suffix = "";
                prefix = "in ";
                delta = Math.abs(delta);
            }

            if (delta < 60) {
                return _t("Just now", "Gerade eben");
            } else if (delta < 2 * 60) {
                return prefix + _t("about one minute", "ca. einer Minute") + suffix;
            } else if (delta < 60 * 60) {
                return prefix + `${parseInt(delta / 60)} min` + suffix;
            } else if (delta < 100 * 60) {
                return prefix + _t("about one hour", "ca. einer Stunde") + suffix;
            } else if (delta < 24 * 60 * 60) {
                let hours = parseInt(delta / (60 * 60));
                let minutes = parseInt((delta - (hours * 60 * 60)) / 60);

                if (minutes === 1) {
                    minutes = _t("one", "eine");
                }

                return prefix + `${hours} h, ${minutes} min` + suffix;
            } else if (delta < 26 * 60 * 60) {
                if (isInTheFuture) {
                    return _t("tomorrow", "Morgen");
                } else {
                    return _t("yesterday", "Gestern");
                }
            } else {
                const dayOfWeek = daysOfWeek[date.getDay()];
                const month = months[date.getMonth()];

                if (de) {
                    return `${dayOfWeek}, ${date.getDate()}. ${month} ${date.getFullYear()}` +
                        (includeTime ? ` ${zeroPad(date.getHours())}:${zeroPad(date.getMinutes())} Uhr` : "");
                } else {
                    return `${dayOfWeek}, ${month} ${date.getDate()}, ${date.getFullYear()}` +
                        (includeTime ? ` ${zeroPad(date.getHours() % 12 || 12)}:${zeroPad(date.getMinutes())} ${date.getHours() < 12 || date.getHours() === 24 ? "am" : "pm"}` : "");
                }
            }
        }
    }

    function reset() {
        chatEnded = false;

        for (let token of cancellationTokens) {
            token.cancelled = true;
        }

        cancellationTokens = [];
    }

    let cancellationTokens = [];

    function createCancellationToken() {
        const token = {};
        cancellationTokens.push(token);
        return token;
    }

    function releaseCancellationToken(token) {
        const index = cancellationTokens.indexOf(token);

        if (index >= 0) {
            cancellationTokens.splice(index, 1);
        }
    }

    function wait(milliseconds) {
        if (window.location.href.includes("chat_no_delay=1")) {
            milliseconds = 0;
        }

        const token = createCancellationToken();

        return new Promise((resolve, reject) => {
            window.setTimeout(() => {
                releaseCancellationToken(token);

                if (!token.cancelled) {
                    resolve();
                }
            }, milliseconds);
        });
    }

    async function confirmClose() {
        if (chatEnded) {
            return true;
        }

        const buttons = [{
            caption: _t("Close the chat", "Chat schließen")
        }, {
            caption: _t("Cancel", "Abbrechen")
        }];

        return (await showMessageBox(_t("You won't be able to return to your chat once you've closed it. Would you like to proceed?",
            "Wenn du den Chat schließt, kannst du später nicht mehr zu ihm zurückkehren. Trotzdem fortfahren?"),
            buttons)) === buttons[0].caption;
    }

    function openChatWindow() {
        $(".quick-help-overlay").addClass("visible");
    }

    async function closeChatWindow() {
        if (await confirmClose()) {
            $(".quick-help-overlay").removeClass("visible");
        }
    }

    function scrollChatWindowToBottom() {
        chatBox.scrollTop(chatBox.prop("scrollHeight"));
    }

    let lastDisplaySpeaker = null;

    let bot = {
        alias: "Sadie",
        avatar: "sadie"
    };

    let agent = {
        alias: "Melanie",
        avatar: "melanie"
    };

    async function showStatus(message, speaker) {
        const element = $(`<div class="message"><div class="avatar ${speaker.avatar}"></div><div class="status">
                        ${message}
                    </div></div>`);
        messageList.append(element);
        scrollChatWindowToBottom();
    }

    async function say(...messages) {
        let speaker = bot;
        let maxIndex = messages.length - 1;

        if (messages.length > 1 && [bot, agent].includes(messages[maxIndex])) {
            speaker = messages[maxIndex];
            --maxIndex;
        }

        const randomIndex = parseInt(Math.random() * (maxIndex + 1));
        const chosenMessage = messages[randomIndex];

        await wait(1000 + (Math.random() * 600));

        let speakerChanged = speaker !== lastDisplaySpeaker;

        if (speakerChanged) {
            messageList.append(`<div class="speaker">${speaker.alias}</div>`);
        }

        lastDisplaySpeaker = speaker;

        const element = $(`<div class="message"><div class="avatar${!speakerChanged ? " suppressed" : ""} ${speaker.avatar}"></div><div class="typing">
                        <span></span><span></span><span></span>
                    </div></div>`);
        messageList.append(element);
        scrollChatWindowToBottom();

        await wait(Math.min(4500, Math.max(1000, element.text().length * 70)));
        element.empty();
        element.append(`<div class="avatar${!speakerChanged ? " suppressed" : ""} ${speaker.avatar}"></div><div>${chosenMessage}</div>`);
        scrollChatWindowToBottom();

        updateSession();
    }

    function ajax(message, payload) {
        return new Promise((resolve, reject) => {
            const token = createCancellationToken();

            jQuery.ajax({
                type: "POST",
                url: "/wp-admin/admin-ajax.php",
                data: Object.assign({
                    action: "instant_help",
                    message: message
                }, payload),
                success: data => {
                    releaseCancellationToken(token);

                    if (token.cancelled) {
                        return;
                    }

                    let decoded;

                    try {
                        decoded = JSON.parse(data);
                        if (!decoded.success) {
                            reject();
                            return;
                        }
                    } catch (e) {
                        reject();
                        return;
                    }

                    ajaxToken = null;
                    resolve(decoded);
                },
                error: reject
            });
        });
    }

    function indefinitely() {
        return new Promise(() => {})
    }

    async function makeRequest(message, payload) {
        let numTries = 1;

        do {
            try {
                await say(_t("One moment...", "Einen Moment..."), _t("One sec...", "Eine Sekunde..."),
                    _t("Just a sec...", "Nur eine Sekunde..."), _t("Just a moment...", "Moment bitte..."),
                    _t("Working on it...", "Ich bin dran..."));
                return await ajax(message, payload);
            } catch (e) {
                console.log(e);
                if (numTries > 3) {
                    await say(_t("Sorry, something's not right. Please try again at a later time.", "Tut mir leid, irgendwas stimmt hier nicht. Bitte versuche es später nochmal."));
                    await indefinitely();
                } else {
                    await say(_t("Oops, Something went wrong. Please check your internet connection and try again.", "Ooops! Das hat nicht geklappt. Bitte überprüfe deine Internetverbindung und versuche es erneut."));
                    await choose({
                        caption: _t("Try again", "Nochmal versuchen")
                    });
                    ++numTries;
                }
            }
        } while (true);
    }

    async function submitTicket(ticket) {
        return makeRequest("submit_ticket", Object.assign({
            transcript: getTranscript(),
            session: session
        }, ticket));
    }

    function getTranscript() {
        let lastSpeaker = "Unknown";
        let transcript = [];

        messageList.find("> div").each((index, element) => {
            element = $(element);
            if (element.is(".speaker")) {
                lastSpeaker = element.text();
            } else if (element.is(".message")) {
                let text = "";

                if (element.find(".multiple-answers").length > 0) {
                    text = element.find(".multiple").map((index, element) => $(element).text()).get().join(", ");
                } else if (element.find(".uploaded-image").length > 0) {
                    text = "<image>";
                } else {
                    text = element.text();
                }

                transcript.push((element.hasClass("theirs") ? "Customer" : lastSpeaker) + ": " + text.trim()
                    .replace(/\s+/g, " ").replace(/^\s+/g, ""));
            } else if (element.is(".status")) {
                transcript.push("[" + element.text() + "]");
            }
        });

        return transcript.join("\n");
    }

    let defaultValidator = () => true;

    function showRatingTool() {
        lastDisplaySpeaker = null;

        return new Promise(async (resolve, reject) => {
            await wait(500);
            const element = $(`<div class="message theirs rating">
            <ul>
                    <li>
                        <svg viewBox="0 0 10 10">
                            <polygon points="5,1.1 6.3,3.7 9.1,4.1 7.1,6.1 7.6,8.9 5,7.6 2.4,8.9 2.9,6.1 0.9,4.1 3.7,3.7 "></polygon>
                        </svg>
                    </li>
                    <li>
                        <svg viewBox="0 0 10 10">
                            <polygon points="5,1.1 6.3,3.7 9.1,4.1 7.1,6.1 7.6,8.9 5,7.6 2.4,8.9 2.9,6.1 0.9,4.1 3.7,3.7 "></polygon>
                        </svg>
                    </li>
                    <li>
                        <svg viewBox="0 0 10 10">
                            <polygon points="5,1.1 6.3,3.7 9.1,4.1 7.1,6.1 7.6,8.9 5,7.6 2.4,8.9 2.9,6.1 0.9,4.1 3.7,3.7 "></polygon>
                        </svg>
                    </li>
                    <li>
                        <svg viewBox="0 0 10 10">
                            <polygon points="5,1.1 6.3,3.7 9.1,4.1 7.1,6.1 7.6,8.9 5,7.6 2.4,8.9 2.9,6.1 0.9,4.1 3.7,3.7 "></polygon>
                        </svg>
                    </li>
                    <li>
                        <svg viewBox="0 0 10 10">
                            <polygon points="5,1.1 6.3,3.7 9.1,4.1 7.1,6.1 7.6,8.9 5,7.6 2.4,8.9 2.9,6.1 0.9,4.1 3.7,3.7 "></polygon>
                        </svg>
                    </li>
                </ul>
            </div>`);

            element.find("li").on("mouseover", function () {
                $(this).addClass("selected");
                $(this).nextAll().removeClass("selected");
                $(this).prevAll().addClass("selected");
            });

            element.find("li").click(() => {
                element.find("li").off("mouseover");
                element.find("ul").off("mouseout");
                element.addClass("frozen");
                resolve(element.find("li.selected").length);
            });

            element.find("ul").on("mouseout", () => {
                element.find("li").removeClass("selected");
            });

            messageList.append(element);

            scrollChatWindowToBottom();
        });
    }

    async function choose(...options) {
        lastDisplaySpeaker = null;

        return new Promise(async (resolve, reject) => {
            await wait(500);
            const element = $(`<div class="message theirs"></div>`);

            const handleInputMouseDown = function (e) {
                if ($(this).hasClass("activated")) {
                    e.stopPropagation();
                    e.preventDefault();
                    $(this).find("input, textarea").focus();
                }
            };

            const handleInputKeyUp = function (e) {
                $(this).parents(".option").find(".error").removeClass("visible");
                if (e.keyCode === 13 || e.keyCode === 10) {
                    $(this).parents(".option").find("button").click();
                }
            };

            const handleInputBlurred = async function () {
                await wait(100);
                if (!$(this).is(":focus")) {
                    $(this).parents(".option").first().removeClass("activated");
                    $(this).parents(".option").find(".error").removeClass("visible");
                }
            };

            const uploadCallback = function () {
                $(this).find("input").get(0).click();
            };

            const handleUploadInputChanged = function () {
                if (!window.FileReader) {
                    return showMessageBox(_t("Sorry, image upload does not appear to be supported by your browser.",
                        "Tut mir leid, aber dein Browser scheint keinen Bilder-Upload zu unterstützen."));
                }

                const input = this;
                const file = input.files[0];

                if (file.size > MAX_FILE_SIZE * 1024 * 1024) {
                    input.value = "";
                    return showMessageBox(_t(`Sorry, this image is too big. The maximum size is ${MAX_FILE_SIZE} MB. Please select a different image and try again.`,
                        `Sorry, dieses Bild ist zu groß. Die Maximalgröße ist ${MAX_FILE_SIZE} MB. Bitte wähle eine anderes Bild aus und versuche es nochmal.`));
                }

                if (file.size < 512) {
                    input.value = "";
                    return showMessageBox(_t(`Sorry, this image appears to be corrupted. Please select a different image and try again.`,
                        `Sorry, diese Datei scheint beschädigt zu sein. Bitte wähle eine anderes Bild aus und versuche es nochmal.`));
                }

                if (file.type !== "image/jpeg") {
                    input.value = "";
                    return showMessageBox(_t(`Sorry, only JPEG images are supported. Please select a different image and try again.`,
                        `Tut mir leid, es werden nur JPEG Bilder unterstützt. Bitte wähle eine anderes Bild aus und versuche es nochmal.`));
                }

                const reader = new FileReader();
                reader.onload = function () {
                    const view = new Uint8Array(this.result);

                    const isJpeg = view[0] === 0xFF && view[1] === 0xD8 && view[2] === 0xFF;

                    if (!isJpeg) {
                        input.value = "";
                        return showMessageBox(_t(`Sorry, only JPEG images are supported. Please select a different image and try again.`,
                            `Tut mir leid, es werden nur JPEG Bilder unterstützt. Bitte wähle eine anderes Bild aus und versuche es nochmal.`));
                    }

                    reader.onload = e => {
                        const image = new Image();

                        image.onload = () => {
                            element.find("div").remove();
                            element.append(`<div>
                            <img class="uploaded-image" style="max-width: 150px">
                            </div>`);

                            element.find(".uploaded-image").attr("src", image.src);
                            resolve(image);
                        };

                        image.onerror = () => {
                            return showMessageBox(_t(`Sorry, this image appears to be corrupted. Please select a different image and try again.`,
                                `Sorry, diese Datei scheint beschädigt zu sein. Bitte wähle eine anderes Bild aus und versuche es nochmal.`));
                        };

                        image.src = e.target.result;
                    };

                    reader.readAsDataURL(file);
                };
                reader.onerror = () => {
                    input.value = "";
                    return showMessageBox(_t(`Sorry, there was a problem reading that image. Please select a different image and try again.`,
                        `Tut mir leid, es gab ein Problem beim lesen dieser Bilddatei. Bitte wähle eine anderes Bild aus und versuche es nochmal.`));
                };
                reader.readAsArrayBuffer(file);
            };

            let multipleConfirm;

            const multipleClicked = function () {
                let element = $(this);
                element.toggleClass("selected");

                const count = element.parent().find(".selected").length;

                if (count < 1) {
                    multipleConfirm.addClass("disabled").find("span").text("0");
                } else {
                    multipleConfirm.removeClass("disabled").find("span").text(count);
                }

                multipleConfirm.addClass("changed").one("animationend", () => {
                    multipleConfirm.removeClass("changed");
                });
            };

            const handleMultipleConfirmed = function() {
                const container = $(this).parents(".theirs").removeClass("multiple");
                container.first().find("> :not(.selected)").remove();
                $(this).remove();

                const section = $(`<section class="multiple-answers"></section>`);

                const selected = [];

                container.find(".selected").each((index, element) => {
                   selected.push($(element).data("value"));
                });

                container.find(".option").removeClass("selected").removeClass("option").find(".checkmark").remove();
                container.find(".multiple").each((index, element) => {
                    section.append($(element));
                });
                container.append(section);

                resolve(selected);
            };

            const deleteCallback = function () {
                const element = $(this);
                const value = element.data("value");

                const container = element.parents(".theirs").first();

                container.prev(".theirs").remove();
                container.remove();

                resolve(value);
            };

            const callback = function () {
                let element = $(this);
                let self = this;

                if (element.hasClass("input")) {
                    element.addClass("activated");
                    element.find("input, textarea").focus();
                    return;
                }

                let value = "";

                if (element.is("button")) {
                    element = element.parents(".option").first();
                    value = element.find("input, textarea").val();
                    const validator = element.data("validator");

                    let result = validator(value);
                    if (result !== true) {
                        element.find(".error").find("span:first-child").text(result);
                        element.find(".error").addClass("visible");
                        return;
                    }

                    self = element.get(0);
                } else {
                    value = element.data("value");
                }

                element.parent().children().each((index, child) => {
                    if (child !== self) {
                        $(child).remove();
                    }
                });
                element.removeClass("option");
                if (element.hasClass("input")) {
                    element.html(element.data("displayText").replace("%%", sanitize(value).replace(/(\r|\n)+/g, "<br>")));
                }
                element.off("click");
                element.off("mousedown");
                resolve(value);
            };

            let optionElement;
            let activeElement;

            let hasMultipleChoice = false;

            for (let option of options) {
                const type = option.type || "default";
                const value = option.value || option.caption;
                const validator = option.validator || defaultValidator;
                const displayText = option.displayText || "%%";

                switch (type) {
                    case "default":
                        optionElement = $(` <div class="option" data-value="${value}">${option.caption}</div>`);
                        optionElement.one("click", callback);
                        break;
                    case "delete":
                        optionElement = $(` <div class="option delete" data-value="${value}">${option.caption}</div>`);
                        optionElement.one("click", deleteCallback);
                        break;
                    case "multiple":
                        optionElement = $(` <div class="option multiple" data-value="${value}"><span class="checkmark"></span>${option.caption}</div>`);
                        optionElement.on("click", multipleClicked);
                        hasMultipleChoice = true;
                        element.addClass("multiple");
                        break;
                    case "countdown":
                        optionElement = $(` <div class="option counter disabled" data-seconds="${option.seconds || 10}" data-value="${value}">${option.caption}<span></span></div>`);
                        optionElement.one("click", callback);
                        break;
                    case "take-picture":
                    case "upload":
                        let accept = "";
                        if (type === "take-picture") {
                            accept = " accept=\"image/*;\"";
                        }
                        optionElement = $(`
                            <div class="option ${type}">
                                <span>${option.caption}</span> <input type="file"${accept} style="display: none">
                            </div>
                        `);
                        optionElement.on("click", uploadCallback);
                        optionElement.find("input").on("change", handleUploadInputChanged);
                        break;
                    case "input":
                        optionElement = $(` <div class="option input" data-value="${value}"><span class="caption">${option.caption}</span> <input placeholder="${option.placeholder}"> <button></button><span class="error"><span></span><span></span></span></div>`);
                        optionElement.data("validator", validator);
                        optionElement.data("displayText", displayText);
                        optionElement.on("click", callback);
                        optionElement.on("mousedown", handleInputMouseDown);
                        optionElement.find("input").on("blur", handleInputBlurred);
                        optionElement.find("input").on("keyup", handleInputKeyUp);
                        optionElement.find("button").on("click", callback);
                        if (options.length === 1 || option.active) {
                            activeElement = optionElement;
                        }
                        break;
                    case "multiline":
                        optionElement = $(` <div class="option input" data-value="${value}"><span class="caption">${option.caption}</span> <textarea rows="5" placeholder="${option.placeholder}">${option.value}</textarea> <button></button><span class="error"><span></span><span></span></span></div>`);
                        optionElement.data("validator", validator);
                        optionElement.data("displayText", displayText);
                        optionElement.on("click", callback);
                        optionElement.on("mousedown", handleInputMouseDown);
                        optionElement.find("input, textarea").on("blur", handleInputBlurred);
                        optionElement.find("textarea").on("mousedown", e => e.stopPropagation());
                        optionElement.find("button").on("click", callback);
                        if (options.length === 1 || option.active) {
                            activeElement = optionElement;
                        }
                        break;
                }

                element.append(optionElement);
            }

            if (hasMultipleChoice) {
                multipleConfirm = $(`<div class="multiple-confirm disabled"><div><span>0</span> selected</div> <button></button></div>`);
                multipleConfirm.find("button").one("click", handleMultipleConfirmed);
                element.append(multipleConfirm);
            }

            messageList.append(element);
            scrollChatWindowToBottom();

            const node = element.get(0);
            for (let i = 0; i < node.childNodes.length; i++) {
                await wait(80);
                node.childNodes[i].classList.add("visible");
            }

            if (element.find(".counter").length > 0) {
                let startTime = new Date().getTime();

                const interval = window.setInterval(() => {
                    let active = 0;

                    const elapsed = parseInt((new Date().getTime() - startTime) / 1000);
                    element.find(".counter").each((index, element) => {
                       element = $(element);
                       let secondsLeft = Math.max(0, element.data("seconds") - elapsed);

                       if (secondsLeft > 0) {
                           element.find("span").html("&nbsp;(" + secondsLeft + ")");
                           ++active;
                       } else {
                           element.removeClass("counter").removeClass("disabled").find("span").remove();
                       }
                    });

                    if (active <= 0) {
                        window.clearInterval(interval);
                    }
                }, 500);
            }

            if (activeElement) {
                await wait(600);
                activeElement.addClass("activated");
                activeElement.find("input, textarea").focus();
                await wait(100);
                scrollChatWindowToBottom();
            }
        });
    }

    function sanitize(value) {
        if (!value || value.length < 1) {
            return "";
        }

        return value.replace(/&/g, "&amp;").replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&apos;");
    }

    async function askForFeedback() {
        chatEnded = true;

        await say(_t("If you have a second, would you mind rating how well I was able to help you today?",
            "Falls du einen Moment Zeit hast, könntest du kurz bewerten, wie gut ich dir heute weiterhelfen konnte?"));
        const rating = await showRatingTool();
        submitRating(rating);

        await say(_t("Thank you so much for your feedback!", "Vielen lieben Dank für dein Feedback!"));
        await say(_t("Do you want to close the chat?", "Soll ich den Chat schließen?"));
        await choose({
            caption: _t("Yes, please", "Ja, bitte")
        });

        closeChatWindow();
    }

    async function checkSecurityCode() {
        do {
            const securityCode = await choose({
                type: "input",
                caption: _t("The code is...", "Der Code ist..."),
                active: true,
                placeholder: "e.g. 12345",
                validator: value => /^[0-9]{5}$/g.test(value.trim()) ? true : _t("Please enter a 5 digit code", "Bitte gib einen 5-stelligen Code ein")
            }, {
                type: "countdown",
                seconds: 30,
                caption: _t("I did not receive the code", "Ich habe den Code nicht bekommen"),
                value: "not_received"
            });

            if (securityCode === "not_received") {
                return false;
            } else {
                const result = await makeRequest("check_code", {
                    code: securityCode
                });

                if (result.isValid) {
                    return true;
                } else {
                    await say(_t("Hmm, that's not it. Please enter the code exactly like it is shown in the email with no extra characters.",
                        "Hmm, das ist nicht ganz richtig. Bitte gib den Code genau so ein, wie er in der E-Mail steht und ohne zusätzliche Zeichen."),
                        _t("Sorry, that's not the one. Please enter the 5 digit code from the email.", "Tut mir leid, das ist nicht richtig. Bitte gib den 5-stelligen Code aus der E-Mail ein."));
                }
            }
        } while (true);
    }

    async function verifyEmailAddress(email) {
        let tries = 1;

        do {
            await makeRequest("send_code", {
                email: email
            });

            if (tries === 1) {
                await say(_t("I have sent a 5 digit code to <strong>" + sanitize(email) + "</strong>. Please enter it below.",
                    "Ich habe einen 5-stelligen Code an <strong>" + sanitize(email) + "</strong> geschickt. Bitte gib ihn unten ein."));
            } else {
                await say(_t("Okay, I sent another 5 digit code to <strong>" + sanitize(email) + "</strong>. Please enter it below.",
                    "Okay, ich schicke einen neuen 5-stelligen Code an <strong>" + sanitize(email) + "</strong>. Bitte gib ihn unten ein."));
            }

            if (await checkSecurityCode()) {
                await say(_t("That's the one! Thank you!", "Der war's! Vielen Dank!"));
                return true;
            } else {
                ++tries;

                if (tries > 3) {
                    await say(_t("Hmm, this doesn't seem to be working. Sorry!", "Hmm, das scheint nicht zu klappen. Tut mir leid!"));
                    await goToContactForm();
                }
            }
        } while (true);
    }

    async function identifyCustomer() {
        await say(_t("What email address did you use to place your order?", "Mit welcher E-Mail-Adresse hast du die Bestellung aufgegeben?"));
        let email = await choose({
            type: "input",
            caption: _t("My email address is...", "Meine E-Mail Adresse lautet..."),
            placeholder: _t("e.g. name@example.com", "z.B. name@beispiel.com"),
            validator: value => /^.+?@.+?\..+?$/g.test(value.trim()) ? true : _t("This does not look like an email address", "Das sieht nicht nach einer gültigen E-Mail-Adresse aus")
        });

        let tries = 1;

        do {
            let result = await makeRequest("email_has_orders", {
                email: email
            });

            if (!result.hasOrders) {
                if (tries >= 3) {
                    await say(_t("Hmm, that one didn't work either, Sorry!", "Hmm, das hat auch nicht geklappt. Tut mir leid!"));
                    await goToContactForm();
                }

                await say(_t("Hmm, I don't seem to have any orders for that email address. Please check your spelling and try again.",
                    "Hmm, unter dieser E-Mail-Adresse kann ich keine Bestellungen finden. Bitte überprüfe die richtige Schreibweise und versuche es erneut."));

                email = await choose({
                    type: "input",
                    caption: _t("Okay, my email address is...", "Okay, meine E-Mail-Adresse lautet..."),
                    placeholder: _t("e.g. name@example.com", "z.B. name@beispiel.com"),
                    validator: value => /^.+?@.+?\..+?$/g.test(value.trim()) ? true : _t("This does not look like an email address", "Das sieht nicht nach einer gültigen E-Mail-Adresse aus")
                });

                ++tries;
            } else {
                break;
            }
        } while (true);

        await verifyEmailAddress(email);

        return email;
    }

    async function goToContactForm() {
        await say(_t("If you still need assistance, I'd be happy to forward your question to someone on our customer service team.",
            "Falls du immer noch Hilfe benötigst, kann ich deine Anfrage sehr gerne an unser Kundenservice-Team weiterleiten."));
        const answer = await choose({
            caption: _t("Yes, please", "Ja, bitte"),
            value: "yes"
        }, {
            caption: _t("Thanks, I'm good", "Danke, nicht nötig"),
            value: "no"
        });

        if (answer === "yes") {
            await differentQuestion(false, true);
        }

        await askForFeedback();
        await indefinitely();
    }

    async function startOverFindOrder(allowedStatus) {
        await say(_t("Would you like to start over?", "Möchtest du nochmal von vorne anfangen?"));
        if ((await choose({
            caption: _t("Yes, please", "Ja, bitte"),
            value: "yes"
        }, {
            caption: _t("No, thanks", "Nein, danke"),
            value: "no"
        })) === "no") {
           await say(_t("Sorry I couldn't help you today.", "Tut mir leid, dass ich dir heute nicht weiterhelfen konnte"));
           await goToContactForm();
        }
        return await findOrder(allowedStatus);
    }

    async function findOrder(allowedStatus = null) {
        let data = {

        };

        if (window.userSettings && window.userSettings.email) {
            await say(_t(`Did you place the order using the account you are currently logged into, <strong>${window.userSettings.email}</strong>?`,
                `Hast du die Bestellung mit dem Benutzerkonto aufgegeben, an dem du aktuell angemeldet bist: <strong>${window.userSettings.email}</strong>?`));
            let answer = await choose({
                caption: _t("Yes, I did", "Ja, habe ich"),
                value: "yes"
            }, {
                caption: _t("No, I didn't", "Nein, habe ich nicht"),
                value: "no"
            });

            if (answer === "no") {
                data.email = await identifyCustomer();
            }
        } else {
            data.email = await identifyCustomer();
        }

        result = await makeRequest("list_orders", data);

        if (!result.orders || !Array.isArray(result.orders) || result.orders.length < 1) {
            await say(_t("Hmm, I couldn't find any orders for <strong>" + (data.email || window.userSettings.email) + "</strong>. Sorry.",
                "Hmm, Ich konnte für <strong>" + (data.email || window.userSettings.email) + "</strong> keine Bestellungen finden. Tut mir leid."));
            await startOverFindOrder();
        }

        let index = 0;

        for (let order of result.orders) {
            if (allowedStatus && !allowedStatus.includes(order.status)) {
                continue;
            }

            let placed = prettyDate(new Date(order.placed * 1000));
            let additionalItems = "";

            if (order.totalItems === 2) {
                additionalItems = "<p>+1 more item</p>";
            } else if (order.totalItems > 2) {
                additionalItems = `<p>+${order.totalItems - 1} more items</p>`;
            }

            await say(index === 0 ? _t("Is this the order?", "Is das deine Bestellung?") : _t("How about this one?", "Wie sieht es mit der aus?"));
            await say(`<div class="order-view">
                <strong>${_t("Order", "Bestellung")} #${order.id}</strong>
                <p>${order.displayStatus}</p>
                <p>${_t("Placed", "Bestellt")}: ${placed}</p>
                <p>${order.destination}</p>
                <img src="${order.keyProduct}" style="width: 150px; height: 150px;">
                ${additionalItems}
                <p>${_t("Total", "Gesamt")}: ${order.total}</p>
                </div>
            `);
            let answer = await choose({
                caption: _t("Yes, this is it", "Ja, die ist es"),
                value: "yes"
            }, {
                caption: _t("No, not that one", "Nein, nicht die"),
                value: "no"
            });

            if (answer === "yes") {
                return order;
            }

            ++index;
        }

        await say(_t("Sorry, I'm all out of ideas which order you might have in mind.",
            "Tut mir leid, dann habe ich keine Idee mehr, welche Bestellung du meinen könntest."));
        return await startOverFindOrder(allowedStatus);
    }

    async function cancelOrder() {
        await say(_t("Hi there! Sorry to hear you want to <strong>cancel your order</strong>. But I got you covered, babe! 😘",
            "Hi! Tut mir sehr leid, dass du deine <strong>Bestellung stornieren</strong> möchtest. Ich helfe dir weiter! 😘"));

        let order = await findOrder();

        do {
            let canCancel = false;

            switch (order.status) {
                case "placed":
                case "processing":
                case "pending-payment":
                    canCancel = true;
                    break;
                case "preparing-shipment":
                    await say(_t("Sorry, this order has already been processed and cannot be cancelled anymore.",
                        "Tut mir leid, diese Bestellung wurde bereits versandbereit gemacht und kann nicht mehr storniert werden."));
                    break;
                case "shipped":
                    await say(_t("Sorry, this order has already been shipped and therefore cannot be cancelled anymore.",
                        "Tut mir leid, diese Bestellung wurde bereits versandt und kann nicht mehr storniert werden."));
                    break;
                case "delivered":
                    await say(_t("Sorry, this order has already been delivered and therefore cannot be cancelled anymore.",
                        "Tut mir leid, diese Bestellung wurde bereits zugestellt und kann nicht mehr storniert werden."));
                    break;
                case "refunded":
                case "cancelled":
                case "failed":
                    await say(_t("Sorry, this order has already been cancelled.", "Tut mir leid, diese Bestellung wurde bereits storniert."));
                    break;
                default:
                    await say(_t("Sorry, this order can no longer be cancelled.", "Tut mir leid, diese Bestellung kann nicht mehr storniert werden."));
                    break;
            }

            if (!canCancel) {
                order = await startOverFindOrder();
            } else {
                await say(_t("Great!","Großartig!"));
                break;
            }
        } while (true);

        await say(_t("May I ask, why you want to cancel your order?", "Darf ich fragen, warum du die Bestellung stornieren möchtest?"));
        const reason = await choose({
            caption: _t("Forgot to apply coupon", "Hab den Rabattcode vergessen")
        }, {
            caption: _t("Made a mistake", "Hab einen Fehler gemacht")
        }, {
            caption: _t("Took too long to ship", "Der Versand dauert zu lange")
        }, {
            caption: _t("Changed my mind", "Hab mich anders entschieden")
        }, {
            type: "input",
            caption: _t("Something else", "Aus einem anderen Grund"),
            placeholder: ""
        }, {
            caption: _t("Don't want to say", "Möchte ich nicht sagen"),
            value: "none"
        });

        if (reason !== "none") {
            await say(_t("Thank you for your feedback!", "Danke für dein Feedback!"));
        }

        await say(_t("Okay, last chance! Do you really want to cancel your order?",
            "Okay, letzte Chance! Möchtest du die Bestellung wirklich stornieren?"));
        const confirmation = await choose({
            caption: _t("Yes, please", "Ja, bitte"),
            value: "yes"
        }, {
            caption: _t("I changed my mind", "Hab mich umentschieden"),
            value: "no"
        });


        if (confirmation === "yes") {
            await submitTicket({
                type: "cancel-order",
                order: order.id,
                reason: reason
            });
            await say(_t("Okay, your order has been cancelled. It will be refunded within the next 24 to 48 hours.",
                "Okay, deine Bestellung wurde storniert und wird innerhalb von 24-28 Stunden erstattet."));
        } else {
            await say(_t("No worries! Please enjoy your order when you get it!",
                "Kein Problem! Hab Spaß mit deiner Bestellung!"));
        }
    }

    function prettyFollowerCount(count) {
        if (count < 1000) {
            return count + "";
        }

        let integerPart = 0;
        let decimalPart = 0;
        let suffix = "";

        if (count < 1000000) {
            count /= 1000;
            integerPart = parseInt(count);
            decimalPart = Math.floor((count - integerPart) * 10);
            suffix = " K";
        } else {
            count /= 1000000;
            integerPart = parseInt(count);
            decimalPart = Math.floor((count - integerPart) * 10);
            suffix = " M";
        }

        return integerPart + (decimalPart > 0 ? "." + decimalPart : "") + suffix;
    }

    async function findSocialMediaAccount() {
        const platform = await choose({
            caption: "Instagram",
            value: "instagram"
        }, {
            caption: "YouTube",
            value: "youtube"
        }, {
            caption: "TikTok",
            value: "tiktok"
        }, {
            caption: _t("Personal blog", "Persönlicher Blog"),
            value: "blog"
        }, {
            type: "input",
            placeholder: _t("e.g. Pinterest", "z.B. Pinterest"),
            caption: _t("Something else", "Etwas anderes")
        });

        do {
            let account;
            let isUrl = false;

            switch (platform) {
                case "instagram":
                    await say(_t("What's your Instagram username?", "Wie lautet dein Instagram Benutzername?"));
                    account = await choose({
                        type: "input",
                        caption: _t("My Instagram username is...", "Mein Instagram-Name lautet..."),
                        placeholder: _t("e.g. @yourname", "z.B. @deinname"),
                        validator: value => /^@?[a-zA-Z0-9\._]{2,29}$/g.test(value.trim()) ? true :
                            _t("This does not look like an Instagram username", "Das sieht nicht nach einem Instagram-Namen aus")
                    });
                    break;
                case "youtube":
                    await say(_t("What's your YouTube channel name?", "Wie lautet dein YouTube Kanal-Name?"));
                    account = await choose({
                        type: "input",
                        caption: _t("My YouTube channel is...", "Mein YouTube Kanal lautet..."),
                        placeholder: _t("e.g. yourname", "z.B. deinname"),
                        validator: value => /^[a-zA-Z0-9\._]{2,29}$/g.test(value.trim()) ? true :
                            _t("This does not look like an YouTube username", "Das sieht nicht nach einem YouTube Benutzernamen aus")
                    });
                    break;
                case "tiktok":
                    await say(_t("What's your TikTok username?", "Wie lautet dein TikTok Benutzername?"));
                    account = await choose({
                        type: "input",
                        caption: _t("My TikTok username is...", "Mein TikTok Benutzername lautet..."),
                        placeholder: _t("e.g. yourname", "z.B. deinname"),
                        validator: value => /^[a-zA-Z0-9\._]{2,24}$/g.test(value.trim()) ? true :
                            _t("This does not look like an TikTok username", "Das sieht nicht nach einem TikTok Benutzernamen aus")
                    });
                    break;
                case "blog":
                    await say(_t("What's your Blog's URL?", "Wie lautet die Adresse deines Blogs?"));
                    account = await choose({
                        type: "input",
                        caption: _t("My blog's URL is...", "Die Adresse meines Blogs lautet..."),
                        placeholder: _t("e.g. https://www.myblog.com", "z.B. https://www.myblog.com"),
                        validator: value => /^https?:\/\/[^.]+\..+$/g.test(value.trim()) ? true :
                            _t("This does not look like a valid URL", "Das sieht nicht nach einer gültigen Internetadresse aus")
                    });
                    isUrl = true;
                    break;
                default:
                    await say(_t("What's a link to your page/profile?", "Wie lautet diese Adresse deiner Seite/deines Profils?"));
                    account = await choose({
                        type: "input",
                        caption: _t("The link is...", "Die Adresse lautet..."),
                        placeholder: _t("e.g. https://www.platform.com/yourname", "z.B. https://www.platform.com/yourname"),
                        validator: value => /^https?:\/\/[^.]+\..+$/g.test(value.trim()) ? true :
                            _t("This does not look like a valid URL", "Das sieht nicht nach einer gültigen Internetadresse aus")
                    });
                    isUrl = true;
                    break;
            }

            const response = await makeRequest("get_social_media_profile", {
                platform: platform,
                account: account
            });

            if (!response.profile) {
                if (isUrl) {
                    await say(_t("I'm sorry, but I couldn't find that URL. Please check your spelling and try again.",
                        "Tut mir leid, diese Internetadresse konnte ich leider nicht finden. Bitte überprüfe die Schreibweise und versuche es erneut."));
                } else {
                    await say(_t("I'm sorry, but I couldn't find that account. Please check your spelling and try again.",
                        "Tut mir leid, dieses Profil konnte ich leider nicht finden. Bitte überprüfe die Schreibweise und versuche es erneut."));
                }
                continue;
            }

            await say(_t("Great! Is this you?", "Super! Das bist also du?"));

            let image = "";

            if (response.profile.picture) {
                image = `<img src="/wp-content/themes/lethalcosmetics/instant-help/image.php?src=${encodeURIComponent(response.profile.picture)}">`;
            }

            let followers = "";

            if (response.profile.followers) {
                followers = `<span class="followers">${prettyFollowerCount(parseInt(response.profile.followers))} Followers</span>`;
            }

            await say(`
                <div class="social-profile">
                    <span class="name">${sanitize(response.profile.displayName)}</span>
                    ${image}                   
                    <span class="username">${sanitize(response.profile.username)}</span>     
                    ${followers}               
                </div>
            `);

            const answer = await choose({
                caption: _t("Yes, that's me", "Ja, das bin ich"),
                value: "yes"
            }, {
                caption: _t("Nope", "Äh, nein"),
                value: "no"
            });

            if (answer === "no") {
                await say(_t("No worries! Please check your spelling and try again.", "Kein Problem! Überprüfe die Schreibweise und versuche es erneut!"));
            } else {
                return Object.assign({
                    platform: platform
                }, response.profile);
            }
        } while (true);
    }

    async function collab() {
        await say(_t("Hey gorgeous! I'm so thrilled that you want to <strong>collab</strong> with us 😍!",
            "Hallo Schönheit! Ich freue mich riesig, dass du mit uns <strong>zusammenarbeiten</strong> möchtest 😍!"));
        await say(_t("What platform would you say is your main one?", "Auf welcher Plattform bist du am meisten unterwegs?"));

        let ticket = {
            type: "collab",
            profiles: []
        };

        do {
            let profile = await findSocialMediaAccount();

            if (profile.isPrivate) {
                await say(_t("Sorry, we unfortunately do not collaborate with private accounts. Do you want to try another social media acount?",
                    "Tut mir leid, wir können leider nicht mit privaten Profilen zusammenarbeiten. Möchtest du stattdessen ein anderes Profil angeben?"));
                if ((await choose({
                    caption: _t("Yes, please", "Ja, bitte"),
                    value: "yes"
                }, {
                    caption: _t("No, thanks", "Nein, danke"),
                    value: "no"
                })) === "yes") {
                  await say(_t("What other social media account should we check out?", "Welche anderen Profile von dir sollten wir uns noch ansehen?"));
                  continue;
                } else {
                    return;
                }
            } else {
                ticket.profiles.push(profile);

                await say(_t("Do you have any other social media accounts you want to submit for our review?",
                    "Hast du noch andere Social Media Profile, die wir uns ansehen sollten?"));
                if ((await choose({
                    caption: _t("Yes, I do", "Ja, das habe ich"),
                    value: "yes"
                }, {
                    caption: _t("No, that's it", "Nein, das ist alles"),
                    value: "no"
                })) === "yes") {
                    await say(_t("What other social media account should we check out?",
                        "Welche anderen Profile sollten wir uns ansehen?"));
                    continue;
                } else {
                    break;
                }
            }
        } while (true);

        await say(_t("What content do you <strong>primarily</strong> share on your social channels?",
            "Welche Art von Content teilst du <strong>hauptsächlich</strong> auf deinen Social Media Kanälen?"));
        ticket.primaryContent = await choose({
            caption: _t("Makeup looks", "Makeup-Looks"),
            value: "makeup-looks"
        }, {
            caption: _t("Makeup reviews", "Makeup-Reviews"),
            value: "makeup-reviews"
        }, {
            caption: _t("Makeup tutorials", "Schminkanleitungen"),
            value: "makeup-tutorials"
        }, {
            caption: _t("Fashion looks", "Outfits bzw. Mode"),
            value: "fashion-looks"
        }, {
            caption: _t("Personal posts/vlog", "Persönliches/Vlog"),
            value: "personal"
        }, {
            caption: _t("Other", "Sonstiges"),
            placeholder: _t("e.g. recipes", "z.B. Rezepte"),
            type: "input"
        });

        await say(_t("Got it!", "Alles klar!"));
        await say(_t("Last question: 🙈", "Letze Frage: 🙈"));
        await say(_t("What email address can we use to get in touch with you?",
            "Unter welcher E-Mail-Adresse können wir dich erreichen?"));

        ticket.email = await choose({
            caption: _t("My email address is...", "Meine E-Mail Adresse lautet..."),
            type: "input",
            placeholder: _t("e.g. name@example.com", "z.B. name@beispiel.de"),
            validator: value => /^.+?@.+?\..+?$/g.test(value.trim()) ? true : _t("This does not look like an email address",
                "Das sieht nicht nach einer gültigen E-Mail-Adresse aus")
        });

        await submitTicket(ticket);

        await say(_t("Okay, that's it! 🙌 Thank you so much!", "Okay, das ist alles! 🙌 Vielen Dank!"));
        await say(_t("Our social media team will review your info and get back to you in about <strong>5 business days</strong>.",
            "Unser Social Media Team wird sich in ca. <strong>5 Werktagen</strong> mit dir in Verbindung setzen."));
    }

    async function showMessageBox(message, buttons = ["Okay"]) {
        const window = new ModalWindow("30rem", "auto", {
            lightDismiss: false,
            closeButton: false,
            buttons: buttons
        });
        window.append(message);

        const result = await window.show();
        window.remove();

        return result;
    }

    async function askForImageUpload(maxCount = 1) {
        const options = [{
            caption: _t("Upload image", "Bild hochladen"),
            type: "upload"
        }];

        const optionsAnother = [{
            caption: _t("Upload another image", "Noch ein Bild hochladen"),
            type: "upload"
        }, {
            caption: _t("Delete last picture", "Letztes Bild löschen"),
            type: "delete",
            value: "delete"
        }, {
            caption: _t("That should do", "Das sollte reichen"),
            value: "done"
        }];

        if (isMobile()) {
            options.unshift({
                caption: _t("Take picture", "Bild aufnehmen"),
                type: "take-picture"
            });
            optionsAnother.unshift({
                caption: _t("Take another picture", "Noch ein Bild aufnehmen"),
                type: "take-picture"
            });
        }

        let count = 0;
        let images = [];

        while (count < maxCount) {
            if (count === 0) {
                const image = await choose(...options);
                images.push(image);
                ++count;
            } else {
                const image = await choose(...optionsAnother);

                if (image === "delete") {
                    images.pop();
                    --count;
                } else if (image === "done") {
                    break;
                } else {
                    images.push(image);
                    ++count;
                }
            }

            if (count === maxCount) {
                const response = await choose({
                    caption: _t("Delete last picture", "Letztes Bild löschen"),
                    type: "delete",
                    value: "delete"
                }, {
                    caption: _t("That should do", "Das sollte reichen"),
                    value: "done"
                });

                if (response === "done") {
                    break;
                } else if (response === "delete") {
                    images.pop();
                    --count;
                }
            }
        }

        return await imagesToBase64(images);
    }

    function blobToBase64(blob) {
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result.substr(reader.result.indexOf(",") + 1));
            reader.readAsDataURL(blob);
        });
    }

    async function conformImage(image) {
        if (!image.complete) {
            await new Promise((resolve, reject) => {
                image.onload = resolve;
                image.onerror = reject;
            });
        }

        let targetWidth, targetHeight;

        if (image.width > image.height) {
            targetWidth = Math.min(2000, image.width);
            targetHeight = parseInt(targetWidth * (image.height / image.width));
        } else {
            targetHeight = Math.min(2000, image.height);
            targetWidth = parseInt(targetHeight * (image.width / image.height));
        }

        const targetCanvas = document.createElement("canvas");
        targetCanvas.width = targetWidth;
        targetCanvas.height = targetHeight;

        const context = targetCanvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height, 0, 0, targetWidth, targetHeight);

        return await new Promise((resolve, reject) => {
            targetCanvas.toBlob(blob => {
                resolve(blob);
            }, "image/jpeg", 70);
        });
    }

    async function imagesToBase64(images) {
        const result = [];

        for (let image of images) {
            result.push(await blobToBase64(await conformImage(image)));
        }

        return result;
    }

    async function selectOrderItems(items, allowMultiple) {
        return await choose(...items.map(item => {
            return {
                caption: `<div class="product"><img src="${item.image}"><span>${item.name}</span></div>`,
                value: item.id,
                type: allowMultiple ? "multiple" : "default"
            };
        }));
    }

    function isMobile() {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    }

    async function askForBatchNumbers(products)
    {
        const byType = {};

        for (let product of products)
        {
            if (typeof(byType[product.type]) === "undefined")
            {
                byType[product.type] = [];
            }

            byType[product.type].push(product);
        }

        let hasShownIntro = false;

        let result = {};

        for (let type of Object.keys(byType))
        {
            let explanation;
            let preview;

            switch (type) {
                case "eyeshadow":
                    explanation = _t("With our eyeshadows, the batch number can be found on the label at the bottom of the tin. It starts with \"M\" followed by 4-6 digits.",
                        "Bei unseren Lidschatten steht die Chargennummer auf dem Etikett auf der Rückseite des Pfännchens. Sie beginnt mit \"M\" gefolgt von 4-6 Ziffern.");
                    preview = "M81234";
                    break;
                case "highlighter":
                    explanation = _t("With our highlighters, the batch number can be found on the label at the bottom of the tin. It starts with \"M\" followed 4-6 digits.",
                        "Bei unseren Highlightern steht die Chargennummer auf dem Etikett auf der Rückseite des Pfännchens. Sie beginnt mit \"M\" gefolgt von 4-6 Ziffern.");
                    preview = "M81234";
                    break;
                case "palette":
                    explanation = _t("With our palettes, the batch number can be found on the back of the sleeve next to the barcode. It starts with 1-2 upper case letters followed by 4-6 digits.",
                        "Bei unseren Paletten steht die Chargennummer auf der Rückseite des Schubers neben dem Strichcode. Sie beginnt mit 1-2 Großbuchstaben gefolgt von 4-6 Ziffern.");
                    preview = "WF81234";
                    break;
                case "lip_gloss":
                    explanation = _t("With our lip gloss, the batch number can be found on the label at the bottom of the tube. It starts with \"L\" followed by 4-6 digits.",
                        "Bei unseren Lip Glossen steht die Chargennummer auf dem Etikett auf der Unterseite des Fläschchens. Sie beginnt mit einem \"L\" gefolgt von 4-6 Ziffern.");
                    preview = "L81234";
                    break;
                case "lip_cream":
                    explanation = _t("With our lip cream, the batch number can be found on the label at the bottom of the tube. It starts with \"H\" followed by 4-6 digits.",
                        "Bei unserer Lip Cream steht die Chargennummer auf dem Etikett auf der Unterseite des Fläschchens. Sie beginnt mit einem \"H\" gefolgt von 4-6 Ziffern.");
                    preview = "H81234";
                    break;
                case "liquid_lipstick":
                    explanation = _t("With our liquid lipstick, the batch number can be found on the label at the bottom of the tube. It starts with \"C\" followed by 4-6 digits.",
                        "Bei unseren flüssigen Lippenstiften steht die Chargennummer auf dem Etikett auf der Unterseite des Fläschchens. Sie beginnt mit einem \"C\" gefolgt von 4-6 Ziffern.");
                    preview = "C81234";
                    break;
                case "lipstick":
                    explanation = _t("With our lipstick, the batch number can be found on the label at the bottom of the tube. It starts with \"S\" followed by 4-6 digits.",
                        "Bei unseren Lippenstiften steht die Chargennummer auf dem Etikett auf der Unterseite des Fläschchens. Sie beginnt mit einem \"S\" gefolgt von 4-6 Ziffern.");
                    preview = "S81234";
                    break;
                case "gel_liner":
                    explanation = _t("With our gel liners, the batch number can be found on the label at the bottom of the jar. It starts with \"S\" followed by 4-6 digits.",
                        "Bei unseren Gel Linern steht die Chargennummer auf dem Etikett auf der Unterseite des Tiegels. Sie beginnt mit einem \"S\" gefolgt von 4-6 Ziffern.");
                    preview = "S81234";
                    break;
                case "face_powder":
                    explanation = _t("With our face powders, the batch number can be found on the label at the bottom of the tin. It starts with \"M\" followed 4-6 digits.",
                        "Bei unseren Gesichtspudern steht die Chargennummer auf dem Etikett auf der Rückseite des Pfännchens. Sie beginnt mit \"M\" gefolgt von 4-6 Ziffern.");
                    preview = "M81234";
                    break;
                case "face_palette":
                    explanation = _t("With our face palettes, the batch number can be found on the back of the sleeve next to the barcode. It starts with 1-2 upper case letters followed by 4-6 digits.",
                        "Bei unseren Face Paletten steht die Chargennummer auf der Rückseite des Schubers neben dem Strichcode. Sie beginnt mit 1-2 Großbuchstaben gefolgt von 4-6 Ziffern.");
                    preview = "M81234";
                    break;
                case "mixing_liquid":
                    explanation = _t("With our mixing liquid, the batch number can be found on the label at the front of the bottle. It starts with \"E\" followed 4-6 digits.",
                        "Bei unserer Mischflüssigkeit steht die Chargennummer auf dem Etikett auf der Vorderseite des Fläschchens. Sie beginnt mit \"E\" gefolgt von 4-6 Ziffern.");
                    preview = "M81234";
                    break;
                default:
                    continue;
            }

            if (!hasShownIntro) {
                await say(_t("For regulatory compliance, I need to now ask you for the batch numbers of the damaged products.",
                    "Aufgrund von rechtlichen Vorschriften muss ich dich nach den Chargen-Nummern der beschädigten Produkte fragen."));
                hasShownIntro = true;
            }

            await say(explanation);

            for (let product of byType[type]) {
                await say(_t("Please type in the batch number for \"<strong>" + product.name + "</strong>\".",
                    "Bitte gib die Chargennummer für \"<strong>" + product.name + "</strong>\" ein."));
                const batchNumber = await choose({
                    type: "input",
                    caption: _t("The batch number is...", "Die Chargennummer lautet..."),
                    active: true,
                    placeholder: "e.g. " + preview,
                    validator: value => /^[A-Z0-9]{4,10}$/g.test(value.trim()) ? true : _t("Please enter the code as written on the label", "Bitte gib den Code so wie auf dem Label dargestellt ein")
                }, {
                    type: "countdown",
                    seconds: 10,
                    caption: _t("I can't find the batch number", "Ich kann die Chargennummer nicht finden"),
                    value: "not_found"
                });

                result[product.id] = batchNumber;
            }
        }

        if (hasShownIntro)
        {
            await say(_t("Thank you very much!", "Vielen Dank!"));
        }

        return result;
    }

    async function brokenItem(order = null) {
        const ticket = {
            type: "broken-item"
        };

        if (!order) {
            await say(_t("Hi there! I am so sorry you received a <strong>broken item</strong> 😭. Let's sort this out!",
                "Hi! Es tut mir so leid, dass du einen <strong>defekten Artikel</strong> erhalten hast 😭. Ich kümmere mich darum!"));
        }

        if (!isMobile()) {
            await say(_t("In a sec, I'll ask you to upload pictures of the broken items 📸. Do you maybe want to continue on your phone? 😉",
                "Ich werde dich gleich bitten, Bilder deiner defekten Produkte hochzuladen 📸. Möchtest du vielleicht lieber auf deinem Handy weitermachen? 😉"));
            const answer = await choose({
                caption: _t("Yes, please", "Ja, bitte"),
                value: "yes"
            }, {
                caption: _t("I can do it from here", "Ich habe die Bilder hier"),
                value: "no"
            });

            if (answer === "yes") {
                await say(_t("Sure thing!", "Alles klar!"));
                await say(_t("Just open a browser on your phone and go to <strong>lthl.me/help</strong>",
                    "Öffne einfach deinen Browser auf deinem Handy und gehe auf <strong>lthl.me/help</strong>."));
                await say(_t("See you there! 😘", "Bis gleich! 😘"));
                await indefinitely();
            }
        }

        if (!order) {
            order = await findOrder(["shipped", "delivered"]);
        }

        ticket.order = order.id;

        const result = await makeRequest("get_order_items", {
            order: order.id
        });

        if (!result.items || !Array.isArray(result.items) || result.items.length < 1) {
            await say(_t("Sorry, I couldn't find any items in this order. This appears to be an error.",
                "Tut mir leid, ich konnte in dieser Bestellung keine Artikel finden. Das scheint ein Fehler zu sein."));
            await goToContactForm();
        }

        let brokenItems;

        do {
            await say(_t("Which of these items came broken? You can select more than one.",
                "Welche dieser Artikel sind defekt angekommen? Du kannst mehr als einen auswählen."));

            brokenItems = await selectOrderItems(result.items, true);

            ticket.brokenItems = brokenItems;

            await say(_t("All set or do you want to change your selection?",
                "Passt so, oder möchtest du deine Auswahl nochmal anpassen?"));
            if ((await choose({
                caption: _t("Oops, I made a mistake", "Ooops, ich habe einen Fehler gemacht"),
                value: "no"
            }, {
                caption: _t("All set!", "Passt!"),
                value: "yes"
            })) === "yes") {
                break;
            }
        } while (true);

        await say(_t("Thanks!", "Vielen Dank!"));

        await say(_t(`Please take or upload pictures of <strong>all</strong> the broken products. You can upload up to 5 pictures.`,
            `Bitte lade Bilder <strong>von allen Produkten</strong> hoch, die defekt angekommen sind. Du kannst bis zu 5 Bilder hochladen.`));
        ticket.productImages = await askForImageUpload(5);
        await say(_t("Thank you!", "Vielen Dank!"), _t("Perfect, thanks!", "Perfekt! Danke!"),
            _t("Great, thanks!", "Prima, danke!"), _t("Got it, thanks!", "Ist angekommen, danke!"));

        ticket.batchNumbers = await askForBatchNumbers(brokenItems.map(id => result.items.find(element => element.id === id)));

        await say(_t("Was there any visible damage to the shipping box?",
            "War die Versandverpackung sichtbar beschädigt?"));
        if ((await choose({
            caption: _t("Yes", "Ja"),
            value: "yes"
        }, {
            caption: _t("No", "Nein"),
            value: "no"
        })) === "yes") {
            await say(_t("Do you still have the shipping box?", "Hast du die Versandverpackung noch?"));
            if ((await choose({
                caption: _t("Yes", "Ja"),
                value: "yes"
            }, {
                caption: _t("No", "Nein"),
                value: "no"
            })) === "yes") {
                await say(_t("That's great! Please take a picture of the damaged part of the box and upload it.",
                    "Perfekt! Dann mach bitte eine Foto von dem beschädigten Teil der Verpackung und lade es hoch."));
                ticket.packagingImages = await askForImageUpload(2);
            }
        }

        await say(_t("Okay, that's everything! 🙏", "Okay, das ist alles! 🙏"));

        await submitTicket(ticket);

        await say(_t(`I've forwarded the pictures to Melanie on our customer service team who will <strong>email you in 1-2 business days</strong> with next steps.`,
            `Ich habe die Bilder an Melanie von unserem Kundenservice-Team weitergeleitet. Sie wird sich innerhalb von <strong>1-2 Werktagen</strong> mit dir in Verbindung setzen und die nächsten Schritte besprechen.`));
        await say(_t("Thank you for your patience!", "Vielen Dank für deine Geduld!"));
    }

    async function missingItem(order = null) {
        const ticket = {
            type: "missing-item"
        };

        if (!order) {
            await say(_t("Hi there! I am so sorry something was <strong>mixed up with your order</strong> 😭. Let's sort this out!",
                "Hi! Es tut mir so leid, dass mit deiner Bestellung <strong>etwas durcheinander gekommen ist</strong> 😭. Ich kümmere mich darum!"));
        }

        if (!isMobile()) {
            await say(_t("In a sec, I'll ask you to upload pictures of what you received in your package 📸. Do you maybe want to continue on your phone? 😉",
                "Ich werde dich gleich bitten, Bilder vom Inhalt der Versandverpackung zu machen 📸. Möchtest du vielleicht lieber auf deinem Handy weitermachen? 😉"));
            const answer = await choose({
                caption: _t("Yes, please", "Ja, bitte"),
                value: "yes"
            }, {
                caption: _t("I can do it from here", "Ich mache das von hier"),
                value: "no"
            });

            if (answer === "yes") {
                await say(_t("Sure thing!", "Alles klar!"));
                await say(_t("Just open a browser on your phone and go to <strong>lthl.me/help</strong>",
                    "Öffne einfach einen Browser auf deinem Handy und gehe zu <strong>lthl.me/help</strong>"));
                await say(_t("See you there! 😘", "Bis gleich! 😘"));
                await indefinitely();
            }
        }

        if (!order) {
            order = await findOrder(["shipped", "delivered"]);
        }

        ticket.order = order.id;

        const result = await makeRequest("get_order_items", {
            order: order.id
        });

        if (!result.items || !Array.isArray(result.items) || result.items.length < 1) {
            await say(_t("Sorry, I couldn't find any items in this order. This appears to be an error.",
                "Tut mir leid, ich konnte keine Artikel in dieser Bestellung finden. Das scheint ein Fehler zu sein."));
            await goToContactForm();
        }

        await say(_t("Were any items missing from your order?", "Fehlten Artikel in deiner Bestellung?"));

        if ((await choose({
            caption: _t("Yes", "Ja"),
            value: "yes"
        }, {
            caption: _t("No", "Nein"),
            value: "no"
        })) === "yes") {
            let missingItems;

            do {
                await say(_t("Which of these items were missing? You can select more than one.",
                    "Welche dieser Artikel fehlten? Du kannst mehrere auswählen."));

                missingItems = await selectOrderItems(result.items, true);

                ticket.missingItems = missingItems;

                await say(_t("All set or do you want to change your selection?",
                    "Alles richtig oder möchtest du deine Auswahl noch anpassen?"));
                if ((await choose({
                    caption: _t("Oops, I made a mistake", "Oops, ich haben einen Fehler gemacht"),
                    value: "no"
                }, {
                    caption: _t("All set!", "Fertig!"),
                    value: "yes"
                })) === "yes") {
                    break;
                }
            } while (true);

            await say(_t("Was there any damage to the shipping box?", "War die Versandverpackung beschädigt?"));

            if ((await choose({
                caption: _t("Yes", "Ja"),
                value: "yes"
            }, {
                caption: _t("No", "Nein"),
                value: "no"
            })) === "yes") {
                await say(_t("Do you still have the shipping box?", "Hast du die Versandverpackung noch?"));
                if ((await choose({
                    caption: _t("Yes", "Ja"),
                    value: "yes"
                }, {
                    caption: _t("No", "Nein"),
                    value: "no"
                })) === "yes") {
                    await say(_t("That's great! Please take a picture of the damaged part of the box and upload it.",
                        "Perfekt! Bitte mach ein Bild der beschädigten Stelle der Versandverpackung und lade es hoch."));
                    ticket.packagingImages = await askForImageUpload(2);
                }
            }
        }

        await say(_t("Thanks!", "Danke dir!"));
        await say(_t("Last question: did you receive any items that you did not in fact order?",
            "Letzte Frage: hast du Artikel erhalten, die du gar nicht bestellt hast?"));

        if ((await choose({
            caption: _t("Yes", "Ja"),
            value: "yes"
        }, {
            caption: _t("No", "Nein"),
            value: "no"
        })) === "yes") {
            await say(_t("Sorry about that! Please enter the names of the items you received but did not order.",
                "Das tut mir leid! Bitte gib unten die Namen der Artikel ein, die du erhalten aber nicht bestellt hast."));

            ticket.wrongItems = await choose({
                caption: _t("I wrongly received...", "Ich habe erhalten..."),
                type: "multiline",
                value: "",
                placeholder: ""
            })
        } else {
            await say(_t("Thanks!", "Besten Dank!"));
        }

        await say(_t("Almost done! 😅", "Fast fertig! 😅"));

        await say(_t(`Please take or upload pictures of <strong>everything</strong> that came in your package. You can upload up to 5 pictures.`,
            `Bitte lade Bilder von <strong>allen Artikeln</strong> hoch, die in der Versandverpackung enthalten waren. Du kannst bis zu 5 Bilder hochladen.`));
        ticket.contentsImages = await askForImageUpload(5);

        await say(_t("Okay, that's everything! 🙏", "Alles klar, das war's! 🙏"));

        await submitTicket(ticket);

        await say(_t(`I've forwarded the pictures and info to Melanie on our customer service team who will <strong>email you in 1-2 business days</strong> with next steps.`,
            `Ich habe dir Bilder und deine Angaben an Melanie aus unserem Kundenservice-Team weitergeleitet. Sie wird sich in <strong>1-2 Werktagen</strong> per E-Mail bei dir melden und alles weitere mit dir besprechen.`));
        await say(_t("Thank you so much for your patience!", "Vielen Dank für deine Geduld!"));
    }

    async function trackOrder(status) {
        await say(_t(`Do you want to track your order now?`, "Möchtest du deine Bestellung jetzt nachverfolgen?"));

        const response = await choose({
            caption: _t("No, thanks", "Nein, danke"),
            value: "no"
        }, {
            caption: _t("Yes, please", "Ja, bitte"),
            value: "yes"
        });

        if (response === "yes") {
            await say(_t(`Sure thing! Your tracking number is <strong>${status.trackingNumbers[0]}</strong> and your order is shipped via <strong>${status.postalServiceName}</strong>.`,
                `Kein Problem! Deine Sendungsnummer lautet <strong>${status.trackingNumbers[0]}</strong> und deine Bestellung wurde mit <strong>${status.postalServiceName}</strong> versandt.`));

            if ((await choose({
                caption: _t("Go to tracking page", "Sendungsverfolgung öffnen"),
                value: "yes"
            }, {
                caption: _t("Thanks!", "Danke!"),
                value: "no"
            })) === "yes") {
                await say(_t("Coming right up!", "Nichts lieber als das!"));
                const win = window.open(status.trackingLinks[0]);
                if (!win) {
                    await say(_t(`Oops, I couldn't open the tracking page. Please try this link instead: <a target="_blank" href="${status.trackingLinks[0]}">${status.trackingNumbers[0]}</a>`,
                        `Oops, Das hat nicht geklappt. Bitte klicke stattdessen auf diesen Link: <a target="_blank" href="${status.trackingLinks[0]}">${status.trackingNumbers[0]}</a>`));
                }
            }
        } else {
            await say(_t("Okay then! If you change your mind, you can always track your order by going to the <strong>Where's my order</strong> page.",
                "Okay! Falls du deine Meinung ändern solltest, kannst du die Bestellung immer auf der <strong>Wo ist meine Bestellung</strong>-Seite verfolgen."));
        }
    }

    async function orderDelivered(status, order) {
        await say(_t(`Hmm, it says here that your order was <strong>delivered ${prettyDate(new Date(status.deliveryDate * 1000), false)}</strong>.`,
            `Hmm, laut meinen Aufzeichnungen wurde deine Bestellung <strong>schon geliefert: ${prettyDate(new Date(status.deliveryDate * 1000), false)}</strong>.`));
        await say(_t(`But you didn't receive it? 🤷‍♀️ `, `Aber du hast sie nicht bekommen? 🤷‍♀️ `));
        await choose({
            caption: _t("Nope", "Nein"),
            value: "no"
        });
        await say(_t("I'm so sorry babe!", "Das tut mir sehr leid!"));
        let daysDelayed = ((new Date().getTime() / 1000) - status.deliveryDate) / (60 * 60 * 24);

        let days = parseInt(daysDelayed) + _t(" days", " Tage");
        if (daysDelayed === 1) {
            days = _t("a day", "ein Tag");
        } else if (daysDelayed < 1) {
            days = _t("less than a day", "weniger als ein Tag");
        }

        if (status.statusMessages.length > 0 && status.statusMessages[0].conformed === "pickup") {
            await say(_t("It looks like your package is available for pick-up at a <strong>post office or retail outlet</strong>.",
                "Es sieht so aus, als stünde dein Paket in einer Postfiliale oder einem Laden <strong>zur Abholung bereit</strong>."));
            await say(_t(`Here's what the tracking status says: <strong>&quot;${status.statusMessages[0].raw}&quot;</strong>.`,
                `Der Sendungsstatus besagt: <strong>&quot;${status.statusMessages[0].raw}&quot;</strong>.`));

            const response = await choose({
                caption: _t("It's not there", "Dort ist es nicht"),
                value: "not-there"
            }, {
                caption: _t("Can't find the pick-up location", "Weiß nicht, wo das ist"),
                value: "cant-find"
            }, {
                caption: _t("Great, I'll pick it up", "Alles klar, ich hole es ab"),
                value: "yes"
            });

            if (response === "yes") {
                await say(_t("Awesome! Thank you! 😘", "Großartig! Vielen Dank! 😘"));
                await say(_t("Hope you'll be able to play with your new goodies real soon!",
                    "Ich hoffe du hast bald viel Freude mit deiner Bestellung!"));
            } else {
                await say(_t("Okay, I know someone who can help!", "Okay, ich kenne da jemanden, der helfen kann!"));

                await submitTicket({
                    type: "order-not-delivered",
                    order: order.id
                });

                if (response === "not-there") {
                    await say(_t(`<span class="mention">@${agent.alias}</span>, can you check why order #${status.id} isn't at the pick-up location it's supposed to be at?`,
                        `<span class="mention">@${agent.alias}</span>, kannst du dir mal Bestrellung #${status.id} anschauen? Die Bestellung steht angeblich zur Abholung bereit aber dort ist sie nicht.`));
                } else {
                    await say(_t(`<span class="mention">@${agent.alias}</span>, can you check where order #${status.id} can be picked up?`,
                        `<span class="mention">@${agent.alias}</span>, kannst du mal schauen, wo Bestellung #${status.id} abgeholt werden kann?`));
                }

                await deferToAgent(_t("Sure thing! Looking into it as soon as possible.", "Na klar! Ich schaue mir das schnellstmöglich an!"));

                await say(_t(`${agent.alias} will <strong>email you in 1-2 business days</strong> with more information.`,
                    `${agent.alias} wird sich in <strong>1-2 Werktagen per E-Mail bei dir melden</strong>.`));
                await say(_t("Thank you so much for your patience!", "Vielen Dank für deine Geduld!"));
            }
        } else if (daysDelayed < 4 && status.shippingCountry === "DE") {
            await say(_t(`Unfortunately this sometimes happens with ${status.postalServiceName}. 🙈`,
                `Leider kann das mit ${status.postalServiceName} manchmal passieren. 🙈`));
            await say(_t(`Since it's only been ${days} though, there's a high chance you'll still get your package delivered in the coming days.`,
                `Aber da es nur ${days} her ist, gibt es noch eine sehr gute Chance, dass dein Paket in den nächsten Tagen trotzdem zugestellt wird.`));
            await say(_t(`If you don't have your order by <strong>${prettyDate(new Date(status.deliveryDate * 1000 + (1000 * 60 * 60 * 24 * 5)), false)}</strong>, please ping me so I can kick their 🍑s!`,
                `Falls du deine Bestellung bis <strong>${prettyDate(new Date(status.deliveryDate * 1000 + (1000 * 60 * 60 * 24 * 5)), false)}</strong> nicht erhalten hast, sag mir bitte Bescheid. Dann kann ich ihnen ein bisschen in den 🍑 treten!`));
            await say(_t("In the meantime, please also check with neighbors or housemates! 💡",
                "Frag in der Zwischenzeit am besten auch deine Nachbarn oder Mitbewohner, ob sie das Paket vielleicht angenommen haben! 💡"));
            await say(_t("Thank you so much for your patience!", "Tausend Dank für dein Geduld!"));
        } else {
            await say(_t("Did you check if any of your housemates or neighbors might have it?",
                "Hast du bei deinen Nachbarn oder möglichen Mitbewohnern gefragt, ob sie das Paket eventuell angenommen haben?"));

            let response = await choose({
                    caption: _t("Didn't check", "Hab ich nicht"),
                    value: "no"
                }, {
                    caption: _t("Don't have neighbors", "Hab keine Nachbarn"),
                    value: "no-neighbors"
                }, {
                    caption: _t("Checked but no luck", "Hab ich, aber ohne Erfolg"),
                    value: "yes"
                }
            );

            if (response === "no") {
                await say(_t("Would you do me a favor and check with them? 😉",
                    "Würdest du mir den Gefallen tun und einmal nachfragen? 😉"));

                await choose({
                    caption: _t("Okay, fine 🙄", "Wenn's sein muss 🙄"),
                    value: "yes"
                });

                await say(_t("You're the best! Thank you! 😘", "Du bist toll! Vielen Dank! 😘"));
                await say(_t("Hope you'll be able to play with your new goodies real soon!",
                    "Ich hoffe deine neuen Schätze finden ganz schnell ihren Weg zu dir!"));
                return;
            } else if (response === "no-neighbors") {
                await say(_t("Worth a try! 😅", "War einen Versuch wert! 😅"));
            } else {
                await say(_t("Too bad", "Schade!"));
            }

            await say(_t(`Did you check if your package got delivered to a nearby <strong>${status.postalServiceName}</strong> post office or pick-up location?`,
                `Hast du nachgesehen, ob dein Paket eventuell bei einer <strong>${status.postalServiceName}</strong>-Filiale oder Abholstation in deiner Nähe abgegeben wurde?`));

            response = await choose({
                caption: _t("Didn't check", "Hab ich nicht"),
                value: "no"
            }, {
                caption: _t("Not sure where that would be?", "Weiß nicht wo das sein soll"),
                value: "not-known"
            }, {
                caption: _t("Checked but no luck", "Hab ich, aber ohne Erfolg"),
                value: "yes"
            });

            if (response === "no") {
                await say(_t("Would you do me a favor and check with them? 😉",
                    "Tust du mir den Gefallen und schaust mal nach? 😉"));

                await choose({
                    caption: _t("Okay, fine 🙄", "Nagut 🙄"),
                    value: "yes"
                });

                await say(_t("Great! Thank you! 😘", "Ganz lieben Dank! 😘"));
                await say(_t("Hope you'll be able to play with your new goodies real soon!",
                    "Ich hoffe deine neuen Schätze finden ganz schnell ihren Weg zu dir!"));
                return;
            } else {
                await say(_t("I see", "Verstehe"));
            }

            if (daysDelayed < 4) {
                await say(_t(`Since it's only been ${days}, there's a good chance you'll still get your package delivered in the coming days.`,
                    `Da es nur ${days} her ist, gibt es eine gute Chance, dass dich dein Paket in den nächsten Tagen noch von alleine erreicht.`));
                await say(_t(`This unfortunately happens more than you'd think 🙈.`, `Leider sind solche Verspätungen mit falschem Sendungsstatus häufiger als man denkt 🙈.`));
                await say(_t("There's usually a happy ending though. 😊", "Normalerweise gibt es aber ein Happy Ending. 😊"));
                await say(_t(`If you don't have your order by <strong>${prettyDate(new Date(status.deliveryDate * 1000 + (1000 * 60 * 60 * 24 * 5)), false)}</strong> though, please ping me so I can look into it!`,
                    `Solltest du diene Bestellung bis zum <strong>${prettyDate(new Date(status.deliveryDate * 1000 + (1000 * 60 * 60 * 24 * 5)), false)}</strong> nicht erhalten haben, melde mich bei mir, dann kümmere ich mich darum!`));
                await say(_t("Thank you so much for your patience!", "Vielen lieben Dank für dein Geduld!"));
            } else {
                await say(_t(`Looks like this is a job for my friend ${agent.alias}!`,
                    `Klingt nach einem Auftrag für meine Freundin ${agent.alias}!`));

                await submitTicket({
                    type: "order-not-delivered",
                    order: order.id
                });

                await say(_t(`<span class="mention">@${agent.alias}</span> could you check why order #${status.id} says it was delivered when it clearly wasn't!`,
                    `<span class="mention">@${agent.alias}</span> kannst du nachschauen warum Bestellung #${status.id} als zugestellt angezeigt wird, obwohl sie nicht zugestellt wurde?`));
                await deferToAgent(_t("Sure, I'll check it out as soon as possible", "Klar, schaue ich mir schnellstmöglich an!"));
                await say(_t(`${agent.alias} will <strong>email you in 1-2 business days</strong> with more information.`,
                    `${agent.alias} wird sich <strong>in 1-2 Werktagen per E-Mail</strong> mit weiteren Informationen bei dir melden.`));
                await say(_t("Thank you so much for your patience!", "Vielen lieben Dank für deine Geduld!"));
            }
        }
    }

    async function deferToAgent(message) {
        await wait(2000);
        await showStatus(_t(`${agent.alias} has joined the chat`, `${agent.alias} ist dem Chat beigetreten`), agent);
        await say(message, agent);
        await say(_t("Great! Thanks! 😘", "Super! Danke! 😘"));
        await say(_t("Happy to help!", "Freut mich, dass ich helfen konnte!"), agent);
        await wait(2000);
        await showStatus(_t(`${agent.alias} has left the chat`, `${agent.alias} hat den Chat verlassen`), agent);
    }

    async function orderShipped(status, order) {
        let daysDelayed = ((new Date().getTime() / 1000) - status.estimatedArrivalDate) / (60 * 60 * 24);

        if (status.isDelayed) {
            let maxShippingDelay = 5;

            if (status.shippingCountry === "DE") {
                maxShippingDelay = 3;
            }

            if (daysDelayed < maxShippingDelay) {
                if (status.shippingCountry === "DE") {
                    await say(_t(`Hmm, it's true that domestic shipping usually only takes around ${status.shippingDayRange} days. 🤔`,
                        `Hmm, der Versand innerhalb Deutschlands dauert normalerweise ${status.shippingDayRange} Tage, das stimmt. 🤔`));
                    await say(_t(`At this stage, I wouldn't worry though!`, "Aber zum aktuellen Zeitpunkt brauchst du dir noch keine Sorgen zu machen!"));
                    await say(_t(`When things are busy, delays can sometimes happen!`, "Wenn es in den Versandzentren heiß her geht, kann es leider manchmal zu Verspätungen kommen."));
                } else {
                    await say(_t(`Hmm, it's true that shipping to ${status.shippingCountryName.en} should only take around ${status.shippingDayRange} days. 🤔`,
                        `Es stimmt, dass der Verand nach ${status.shippingCountryName.de} nur ca. ${status.shippingDayRange} Tage dauern sollte. 🤔`));
                    await say(_t(`At this stage, I wouldn't worry though!`, "Aber zum aktuellen Zeitpunkt brauchst du dir noch keine Sorgen zu machen!"));
                    await say(_t("With international shipping, delays can sometimes happen.", "Bei internationalem Versand kann es leider manchmal zu Verspätungen kommen."));

                    if (status.statusMessages.length > 0 && status.statusMessages[0].canonical === "forwarded") {
                        await say(_t(`And according to the tracking info, your package <strong>has already been forwarded to ${status.shippingCountryName.en}</strong>.`,
                            `Und laut Sendungsstatus wurde deine Bestellung <strong>bereits nach ${status.shippingCountryName.de} weitergeleitet</strong>.`));
                    }
                }

                await say(_t(`If you don't have your order by <strong>${prettyDate(new Date(status.estimatedArrivalDate * 1000 + (1000 * 60 * 60 * 24 * (maxShippingDelay + 2))), false)}</strong> though, please ping me so I can look into it!`,
                    `Solltest du dein Paket nicht bis zum <strong>${prettyDate(new Date(status.estimatedArrivalDate * 1000 + (1000 * 60 * 60 * 24 * (maxShippingDelay + 2))), false)}</strong> erhalten haben, melde dich bitte bei mir! Dann kümmere ich mich darum!`));
                await say(_t("Thank you so much for your patience!", "Vielen Dank für deine Geduld!"));
            } else {
                await say(_t("Hmm, your order should have arrived by now. 😓", "Hmm, deine Sendung ist wirklich längst überfällig. 😓"));
                await say(_t("Looks like it needs a push! 💪", "Sieht so aus, als müsste man sie ein wenig anschieben! 💪"));

                await submitTicket({
                    type: "order-delayed",
                    order: order.id
                });

                await say(_t(`<span class="mention">@${agent.alias}</span>, can you check why order #${status.id} hasn't arrived yet?`,
                    `<span class="mention">@${agent.alias}</span>, kannst du dir mal anschauen, warum die Bestellung #${status.id} noch nicht angekommen ist?`));

                await deferToAgent(_t("Sure thing! I'll message the customer once I know more", "Klar! Ich melde mich wenn ich mehr weiß"));

                await say(_t(`${agent.alias} will <strong>email you in 1-2 business days</strong> with more information.`,
                    `${agent.alias} wird <strong>sich in 1-2 Werktagen per E-Mail</strong> mit dir in Verbindung setzen.`));
                await say(_t("Thank you so much for your patience!", "Vielen lieben Dank für deine Geduld!"));
            }
        } else {
            await say(_t("Hang in there! Your order is on its way! 😊", "Ein bisschen Geduld noch, deine Bestellung ist auf dem Weg! 😊"));

            if (daysDelayed < 0 && daysDelayed >= -2) {
                await say(_t(`It should arrive either <strong>today or tomorrow</strong>. 🙏`, `Sie sollte <strong>heute oder morgen</strong> bei dir ankommen. 🙏`));
            } else {
                await say(_t(`It should arrive <strong>around ${prettyDate(new Date(status.estimatedArrivalDate * 1000), false)}</strong>. 🙏`,
                    `Sie sollte ca. <strong>${prettyDate(new Date(status.estimatedArrivalDate * 1000), false)}</strong> bei dir ankommen. 🙏`));
            }

            await trackOrder(status);
        }
    }

    async function orderPlaced(status, order) {
        let daysSinceOrder = ((new Date().getTime() / 1000) - order.orderDate) / (60 * 60 * 24);

        await say(_t("So it looks like this order hasn't shipped yet. 🕵️", "Es sieht so aus, als hätten wir deine Bestellung noch nicht verschickt. 🕵️"));
        await say(_t("So that explains why you haven't received it! 😅", "Was erklärt, warum du sie noch nicht erhalten hast! 😅"));

        if (status.isPreorder) {
            await say(_t("Your order appears to contain preorder items which means it won't ship until they are available.",
                "Deine Bestellung enthält Artikel zur Vorbestellung, was bedeutet sie kann erst dann verschickt werden, wenn diese wieder Verfügbar sind."));
            await say(_t(`In any case, your order should arrive <strong>around ${prettyDate(new Date(status.estimatedArrivalDate * 1000), false)}</strong>. 🙏`,
                `In jedem Fall solltest du deine Bestellung ungefähr <strong>${prettyDate(new Date(status.estimatedArrivalDate * 1000), false)}</strong> bei dir eintreffen. 🙏`));
            await say(_t("Thank you for your patience. 😘", "Vielen Dank für deine Geduld. 😘"));
        } else if (daysSinceOrder < 5) {
            await say(_t("We often ship orders within 24 hours of receiving them, but then there's weekends and public holidays.",
                "Wir verschicken Bestellungen meistens innerhalb von 24 Stunden, ausgenommen natürlich an Wochenenden und Feiertagen."));
            await say(_t("And sometimes we might need an extra day or two depending on order volume.",
                "Und manchmal brauchen wir leider auch ein weniger länger, wenn gerade sehr viele Bestellungen abzuarbeiten sind."));
            await say(_t(`In any case, your order should arrive <strong>around ${prettyDate(new Date(status.estimatedArrivalDate * 1000), false)}</strong>. 🙏`,
                `In jedem Fall solltest du deine Bestellung ungefähr <strong>${prettyDate(new Date(status.estimatedArrivalDate * 1000), false)}</strong> bei dir eintreffen. 🙏`));
            await say(_t("Thank you for your patience. 😘", "Vielen Dank für deine Geduld. 😘"));
        } else {
            if (status.orderBacklog === "heavy") {
                await say(_t("I just checked and it looks like we're working through a lot of orders right now. ⛰️",
                    "Ich habe gerade nachgesehen und wir haben aktuell ein großes Volumen an Bestellungen abzuarbeiten. ⛰️"));
                await say(_t("So unfortunately things might take a little longer than usual.",
                    "Deshalb kann der Versand aktuell leider länger dauern als üblich."));
                await say(_t("I'm really sorry about that, but our team is working hard to ship your order ASAP!",
                    "Das tut mir wirklich sehr leid! Unser Team arbeitet mit Vollgas daran, deine Bestellung schnellstmöglich zu versenden!"));
                await say(_t("Thank you for your patience. 😘", "Vielen Dank für deine Geduld. 😘"));
            } else {
                await say(_t("I'm really sorry it's been taking so long. Could be that our warehouse is backed up by a sale or product launch.",
                    "Es tut mir wirklich sehr leid, dass du schon so lange warten musstest. Es könnte sein, dass unser Lager aktuell viele Bestellungen abzuarbeiteh hat, z.B. nach einem Sale oder Produkt-Launch."));
                await say(_t("Let me ask someone!", "Lass mich jemanden fragen!"));

                await submitTicket({
                    type: "order-delayed",
                    order: order.id
                });

                await say(_t(`<span class="mention">@${agent.alias}</span>, can you check why order #${status.id} hasn't shipped yet?`,
                    `<span class="mention">@${agent.alias}</span>, kannst du mal nachschauen warum Bestellung #${status.id} noch nicht verschickt wurde?`));

                await deferToAgent(_t("Sure thing! I'll message the customer once I know more.", "Klar! Ich melde mich, sobald ich mehr weiß"));

                await say(_t(`${agent.alias} will <strong>email you in 1-2 business days</strong> with more information.`,
                    `${agent.alias} wird sich in <strong>1-2 Werktagen per E-Mail</strong> mit weiteren Informationen bei dir melden.`));
                await say("Vielen Dank für deine Geduld!");
            }
        }
    }

    async function orderFailed(status, order) {
        switch (status.status) {
            case "cancelled":
                await say(_t("🤔, according to my records this order has been cancelled.",
                    "🤔, laut meiner Aufzeichnungen wurde diese Bestellung storniert."));
            case "refunded":
                await say(_t("🤔, according to my records this order has already been refunded.",
                    "🤔, laut meiner Aufzeichnungen wurde diese Bestellung erstattet."));
            case "failed":
                await say(_t("🤔, according to my records, this order has been cancelled automatically because the payment did not go through.",
                    "🤔, laut meiner Aufzeichnungen wurde diese Bestellung automatisch storniert, weil die Zahlung nicht durchgegangen ist."));
            case "on-hold":
                await say(_t("🤔, according to my records, this order is currently on-hold, maybe due to an ongoing payment dispute?",
                    "🤔, laut meiner Aufzeichnungen wird diese Bestellung zurückgehalten, z.B. weil es noch einen ungelösten Zahlungs-Konflikt gibt."));
            case "pending-payment":
                await say(_t("🤔, according to my records, the payment for this order did not get completed.",
                    "🤔, laut meiner Aufzeichnungen wurde die Zahlung für diese Bestellung nicht abgeschlossen."));
        }

        await say(_t("Does this ring a bell? 🤷", "Sagt dir das was? 🤷"));

        let response = await choose({
            caption: _t("Nope", "Nö"),
            value: "no"
        }, {
            caption: _t("Yeah, it does", "Ja, stimmt"),
            value: "yes"
        });

        if (response === "yes") {
            await say(_t("Great! So, no need to investigate this further? 🕵️",
                "Okay! Also kein Grund, weiter nachzuforschen? 🕵️"));

            response = await choose({
                caption: _t("Actually, ...", "Nicht ganz..."),
                value: "no"
            }, {
                caption: _t("Mystery solved!", "Fall geklärt!"),
                value: "yes"
            });

            if (response === "yes") {
                return;
            }
        }

        await say(_t("Okay, this exceeds my sleuthing abilities, but I know just the person!",
            "Okay, das übersteigt meine detektivischen Fähigkeiten, aber ich kenne da jemanden!"));

        await submitTicket({
            type: "order-delayed",
            order: order.id
        });

        await say(_t(`<span class="mention">@${agent.alias}</span>, can you check what's up with order #${status.id}?`,
            `<span class="mention">@${agent.alias}</span>, kannst du mal schauen, was mit Bestellung #${status.id} los ist?`));

        await deferToAgent(_t("Sure thing! I'll message the customer once I know more.",
            "Klar! Ich melde mich, sobald ich mehr weiß"));

        await say(_t(`${agent.alias} will <strong>email you in 1-2 business days</strong> with more information.`,
            `${agent.alias} wird sich innherhalb von <strong>1-2 Werktagen per E-Mail</strong> mir weiteren Informationen bei dir melden.`));
        await say(_t("Thank you so much for your patience!", "Vielen Dank für deine Geduld!"));
    }

    async function orderNotReceived() {
        await say(_t("Hi there! I am so sorry you <strong>haven't received your order</strong> 😭. Let's sort this out!",
            "Hi! Es tut mir sehr leid, dass du deine <strong>Bestellung noch nicht erhalten</strong> hast 😭. Ich kümmere mich darum!"));

        const order = await findOrder(["shipped", "delivered", "placed", "processing", "preparing-shipment"]);

        const result = await makeRequest("get_order_shipping_status", {
            order: order.id
        });

        await say(_t("Okay, let's see:", "Okay, schauen wir mal:"));

        const isShipped = result.status === "delivered" || result.status === "shipped";

        if (isShipped) {
            await say(_t(`This order was shipped <strong>${prettyDate(new Date(result.shipDate * 1000),
                false)}</strong> via <strong>${result.postalServiceName}</strong>.`,
                `Diese Bestellung wurde <strong>${prettyDate(new Date(result.shipDate * 1000),
                    false)}</strong> mit <strong>${result.postalServiceName}</strong> verschickt.`));
        }

        await say(_t(`The shipping address I have is:<br><br>${result.shippingAddress}.`,
            `Die Lieferanschrift lautet:<br><br>${result.shippingAddress}.`));
        const response = await choose({
            caption: _t("That's the wrong address", "Die Adresse ist falsch"),
            value: "wrong-address"
        }, {
           caption: _t("Correct", "Stimmt"),
           value: "yes"
        });

        if (response === "wrong-address") {
            await say(_t("Oh no! 😲 What's the correct address?", "Ohje! 😲 Wie lautet die richtige Adresse?"));
            const address = await choose({
                caption: _t("My address is...", "Meine Adresse lautet..."),
                type: "multiline",
                value: result.shippingAddress.replace(/<.*?>/g, "\n").replace(/(\n|\r)+/g, "\n").trim(),
                placeholder: ""
            });
            await say(_t("Okay, I'll need some help on this", "Okay, hierfür brauche ich ein wenig Hilfe"));

            await submitTicket({
                type: "order-wrong-address",
                order: order.id,
                correctAddress: address
            });

            await say(_t(`<span class="mention">@${agent.alias}</span>, apparently the shipping address for order #${result.id} is wrong...`,
                `<span class="mention">@${agent.alias}</span>, anscheinend stimmt die Lieferanschrift für Bestellung #${result.id} nicht...`));

            await wait(2000);
            await showStatus(_t(`${agent.alias} has joined the chat`, `${agent.alias} ist dem Chat beigetreten`), agent);
            await say(_t("Oops! What's the correct address?", "Oops! Wie lautet die richtige Adresse?"), agent);
            await say(_t(`It's<br>${address.replace(/(\r|\n)+/g, "<br>")}`, `Sie lautet<br>${address.replace(/(\r|\n)+/g, "<br>")}`));
            await say(_t("Okay, I'l see what I can do", "Okay, ich schaue mal, was ich da machen kann"), agent);
            await say(_t("Thanks babe 😘", "Du bist ein Schatz 😘"));
            await wait(2000);
            await showStatus(_t(`${agent.alias} has left the chat`, `${agent.alias} hat den Chat verlassen`), agent);
            await say(_t(`${agent.alias} will <strong>email you in 1-2 business days</strong> with more information.`,
                `${agent.alias} wird sich <strong>in 1-2 Werktagen per E-Mail</strong> mit weiteren Informationen bei dir melden.`));
            await say(_t("She's a magic worker, so let's hope she can sort this out! 🙏",
                `Ich drücke die Daumen, aber ${agent.alias} weiß, was sie tut! 🙏`));
            return;
        } else {
            await say(_t("Great!", "Prima!"));
        }

        switch (result.status) {
            case "delivered":
                await orderDelivered(result, order);
                break;
            case "shipped":
                await orderShipped(result, order);
                break;
            case "placed":
            case "processing":
            case "pending-shipment":
                await orderPlaced(result, order);
                break;
            case "cancelled":
            case "refunded":
            case "failed":
            case "on-hold":
            case "pending-payment":
                await orderFailed(result, order);
                break;
            default:
                await say(_t("I'm so sorry, but this order has a status that I can't make sense of...",
                    "Es tut mir leid, aber diese Bestellung hat einen Status, aus dem ich nicht schlau werde..."));
                await goToContactForm();
                break;
        }
    }

    async function getUserEntry(showHumanWarning = true, requireConfirmation = true, value = null) {
        if (showHumanWarning) {
            if (navigator.language.toLowerCase().indexOf("fr") === 0) {
                await say("Elle sera lue par un humain qui, très probablement, ne parle que l'allemand ou l'anglais. Veuillez utiliser un service de traduction si vous n'êtes pas à l'aise pour écrire dans ces langues.")
            } else if (navigator.language.toLowerCase().indexOf("es") === 0) {
                await say("Esto será leído por un humano que probablemente sólo habla alemán o inglés. Por favor, utilice un servicio de traducción si no se siente cómodo escribiendo en estos idiomas.")
            } else {
                await say(_t(`This will be read by a human who speaks <img style="width: 20px;vertical-align: middle;" src="/wp-content/themes/lethalcosmetics/images/flags/de.svg"> and <img style="width: 20px;vertical-align: middle;" src="/wp-content/themes/lethalcosmetics/images/flags/gb.svg"> / <img style="width: 20px;vertical-align: middle;" src="/wp-content/themes/lethalcosmetics/images/flags/us.svg">.`,
                    `Deine Nachricht wird von einem Menschen gelesen, der <img style="width: 20px;vertical-align: middle;" src="/wp-content/themes/lethalcosmetics/images/flags/de.svg"> und <img style="width: 20px;vertical-align: middle;" src="/wp-content/themes/lethalcosmetics/images/flags/gb.svg"> / <img style="width: 20px;vertical-align: middle;" src="/wp-content/themes/lethalcosmetics/images/flags/us.svg"> versteht.`));
            }
        }

        let input;

        do {
            $(".quick-help-overlay .entry").addClass("visible");
            $(".quick-help-overlay .entry textarea").focus();

            if (value) {
                $(".quick-help-overlay .entry textarea").val(value);
            }

            scrollChatWindowToBottom();

            input = await new Promise((resolve, reject) => {
                entryCallback = value => {
                    entryCallback = null;
                    resolve(value);
                };
            });

            $(".quick-help-overlay .entry").removeClass("visible");

            if (requireConfirmation) {
                await say(_t("All set, or would you like to change your message?",
                    "Alles richtig, oder möchtest du noch etwas korrigieren?"));

                if ((await choose({
                    caption: _t("Whoops, made a mistake", "Oops, da ist noch ein Fehler"),
                    value: "no"
                }, {
                    caption: _t("Looks great", "Sieht gut aus"),
                    value: "yes"
                })) === "no") {
                    await say(_t("No problem! Let's try this again:", "Kein Problem! Nächster Versuch:"));
                    $(".quick-help-overlay .entry textarea").val(input);
                } else {
                    break;
                }
            } else {
                break;
            }
        } while (true);

        return input;
    }

    function getDeviceDescription() {
        const deviceInfo = {
            platform: window.navigator.platform,
            appCodeName: window.navigator.appCodeName,
            appName: window.navigator.appName,
            appVersion: window.navigator.appVersion,
            language: window.navigator.language,
            mimeTypes: window.navigator.mimeTypes,
            oscpu: window.navigator.oscpu,
            vendor: window.navigator.vendor,
            vendorSub: window.navigator.vendorSub,
            product: window.navigator.product,
            productSub: window.navigator.productSub,
            userAgent: window.navigator.userAgent,
            cookieEnabled: window.navigator.cookieEnabled,
            availHeight: window.screen.availHeight,
            availWidth: window.screen.availWidth,
            screenWidth: window.screen.width,
            screenHeight: window.screen.height,
            devicePixelRation: window.devicePixelRatio
        };

        return JSON.stringify(deviceInfo);
    }

    async function technicalProblem() {
        const ticket = {
            type: "technical-problem",
            deviceInfo: getDeviceDescription()
        };

        await say(_t("Hi there! I am so sorry you're <strong>having technical issues with our website</strong> 😭. Let's figure this out!",
            "Hi! Es tut mir sehr leid, dass du <strong>technische Probleme mit unserer Website</strong> hast 😭. Ich kümmere mich darum!"));
        await say(_t("Which part of our website does the issue affect?", "Welcher Teil der Website ist von dem Problem betroffen?"));

        ticket.issue = await choose({
            caption: _t("Payment", "Bezahlung"),
            value: "payment"
        }, {
            caption: _t("Coupons", "Rabattcodes"),
            value: "coupons"
        }, {
            caption: _t("Checkout", "Bestellprozess"),
            value: "checkout"
        }, {
            caption: _t("Shopping cart", "Warenkorb"),
            value: "cart"
        }, {
            caption: _t("Palette designer", "Paletten-Designer"),
            value: "cart"
        }, {
            caption: _t("My account", "Mein Konto"),
            value: "myaccount"
        }, {
            caption: _t("Wishlist", "Wunschliste"),
            value: "wishlist"
        }, {
            caption: _t("Something else", "Etwas anderes"),
            value: "other"
        });

        await say(_t("Got it! Here's a tip that helped a lot of our customers: 🩹",
            "Alles klar! Hier ein Tipp, der schon ganz vielen Kund*innen geholfen hat: 🩹"));
        await say(_t("Try doing the thing that didn't work while in your browser's incognito/private browsing mode.",
            "Öffnen die Website im Incognito-Modus deine Browsers und versuche es nochmal."));
        await say(_t("I promise 8.5 out of 10 times that solves the problem! 🤓",
            "Ich verspreche dir, in 8,5 von 10 Fällen löst sich das Problem so von allein! 🤓"));

        if ((await choose({
            caption: _t("It really helped!", "Das hat wirklich funktioniert!"),
            value: "yes"
        }, {
            caption: _t("That did nothing", "Hat nix gebracht"),
            value: "no"
        })) === "yes") {
            await say(_t("Hurray! 🎉 I'm so glad to hear it!",
                "Hurra! 🎉 Das freut mich sehr!"));
            return;
        }

        await say(_t("Too bad! Please provide a detailed description of what's happening! Be sure to <strong>include any error messages</strong> you might be seeing.",
            "Schade! Dann beschreibe bitte ausführlich das Problem! Bitte erwähne auch <strong>Fehlermeldungen, die dir angezeigt werden</strong>."));
        await say(_t("P.S.: If you have any screenshots you'd like to share, you can do that afterwards.",
            "P.S.: falls du Bildschirmfotos mit uns teilen möchtest, kannst du das direkt im Anschluss machen."));

        ticket.description = await getUserEntry();

        await say(_t("Would you like to upload any screenshots that showcase the problem? 📷",
            "Möchtest du jetzt noch Bildschirmfotos hochladen, die das Problem zeigen? 📷"));

        if ((await choose({
            caption: _t("No, thanks", "Nein, danke"),
            value: "no"
        }, {
            caption: _t("Yes, please", "Ja, bitte"),
            value: "yes"
        })) === "yes") {
            await say(_t("Great! You can upload up to 5 screenshots!",
                "Prima! Du kannst bis zu 5 Screenshots hochladen!"));
            ticket.screenshots = await askForImageUpload(5);
        }

        await say(_t("Last question: 🙈", "Letzte Frage: 🙈"));
        await say(_t("What email address can we use to get in touch with you?",
            "Unter welcher E-Mail-Adresse können wir dich erreichen?"));

        ticket.email = await choose({
            caption: _t("My email address is...", "Meine E-Mail-Adresse lautet..."),
            type: "input",
            placeholder: _t("e.g. name@example.com", "z.B. name@beispiel.de"),
            validator: value => /^.+?@.+?\..+?$/g.test(value.trim()) ? true :
                _t("This does not look like an email address", "Das sieht nicht nach einer gültigen E-Mail Adresse aus")
        });

        await submitTicket(ticket);

        await say(_t(`I've forwarded the information to Melanie on our customer service team who will <strong>email you in 1-2 business days</strong> with next steps.`,
            `Ich habe deine Angaben an Melanie aus unserem Kundenservice-Team weitergeleitet. Sie wird sich innerhalb von <strong>1-2 Werktagen per E-Mail</strong> mit einer Lösung bei dir melden.`));
        await say(_t("Thank you so much for your patience!", "Vielen Dank für deine Geduld!"));
    }

    async function returnItem() {
        const ticket = {
            type: "return-item"
        };

        await say(_t("Hi there! I am so sorry you're <strong>not completely happy with your order</strong> 😭. Let's sort this out!",
            "Hi! Es tut mir sehr leid, dass du mit deiner <strong>Bestellung nicht vollständig zufrieden</strong> bist 😭. Ich kümmere mich darum!"));

        let order = await findOrder(["shipped", "delivered"]);

        const shippingStatus = await makeRequest("get_order_shipping_status", {
            order: order.id
        });

        let estimatedDeliveryDate = shippingStatus.deliveryDate;

        if (estimatedDeliveryDate < 1) {
            estimatedDeliveryDate = shippingStatus.shipDate + shippingStatus.shippingDays * (60 * 60 * 24);
        }

        let daysSinceDelivery = ((new Date().getTime() / 1000) - estimatedDeliveryDate) / (60 * 60 * 24);

        if (daysSinceDelivery > 14) {
            await say(_t("I'm so sorry, but we can only accept returns up until <strong>14 days</strong> after an order has been delivered. 😔",
                "Es tut mir leid, aber Rückesendungen können wir leider nur innerhalb von 14 Tagen nach Zustellung der Sendung annehmen. 😔"));
            return;
        }

        ticket.order = order.id;

        const result = await makeRequest("get_order_items", {
            order: order.id
        });

        if (!result.items || !Array.isArray(result.items) || result.items.length < 1) {
            await say(_t("Sorry, I couldn't find any items in this order. This appears to be an error.",
                "Tut mir leid, aber ich konnte in deiner Bestellung keine Artikel finden. Das scheint ein Fehler zu sein."));
            await goToContactForm();
        }

        await say(_t("Which of these would you like to return? You can select more than one.",
            "Welche dieser Artikel würdest du gerne zurück geben? Du kannst mehrere auswählen."));

        ticket.items = await selectOrderItems(result.items, true);

        await say(_t("Thank you! May I ask why you would like to return these?",
            "Vielen Dank! Darf ich fragen, warum du sie zurückgeben möchtest?"));

        ticket.reason = await choose({
            caption: _t("Don't like the color", "Die Farbe gefällt mir nicht"),
            value: "color"
        }, {
            caption: _t("Not happy with performance", "Tur nicht, was es soll"),
            value: "performance"
        }, {
            caption: _t("Arrived too late", "Kam zu spät an"),
            value: "arrivedlate"
        }, {
            caption: _t("Arrived damaged", "Artikel beschädigt"),
            value: "damaged"
        }, {
            caption: _t("Wrong item was sent", "Falscher Artikel geliefert"),
            value: "wrongitem"
        }, {
            caption: _t("Changed my mind", "Hab mich umentschieden"),
            value: "changedmind"
        }, {
            type: "input",
            caption: _t("Something else", "Etwas anderes"),
            placeholder: ""
        }, {
            caption: _t("Don't want to say", "Möchte ich nicht sagen"),
            value: "none"
        });

        if (ticket.reason === "damaged" || ticket.reason === "wrongitem") {
            await say(_t("I'm sorry to hear that!", "Das tut mir sehr leid!"));

            if (ticket.reason === "damaged") {
                await brokenItem(order);
            } else {
                await missingItem(order);
            }
            return;
        }

        await say(_t("I'm sorry to hear that! Were the products used or swatched in any way?",
            "Das tut mir sehr leid! Hast du die Produkte in irgendeiner Weise benutzt oder geswatcht?"));

        ticket.used = false;

        if ((await choose({
            caption: _t("No, they're untouched", "Nein, sie sind unberührt"),
            value: "no"
        }, {
            caption: _t("Yes, they're swatched", "Ja, ich habe sie geswatcht"),
            value: "yes"
        }, {
            caption: _t("Yes, they've been used", "Ja, ich habe sie benutzt"),
            value: "yes"
        })) === "yes") {
            ticket.used = true;
            await say(_t("For hygienic reasons, we cannot accept returns for products that have been used or swatched. 😥",
                "Aus hygienischen Gründen können wir benutzte oder geswatchte Produkte leider nicht zurücknehmen. 😥"));
            await say(_t("Please don't send anything back to us at this time!",
                "Schicke deshalb bitte noch nichts an uns zurück!"));

            await submitTicket(ticket);

            await say(_t(`I've forwarded your information to Melanie on our customer service team who will <strong>email you in 1-2 business days</strong> with next steps.`,
                `Ich habe deine Anhaben an Melanie aus unserem Kundenservice-Team weitergeleitet. Sie wird sich innerhalb von <strong>1-2 Werktagen per E-Mail</strong> bezüglich der nächsten Schritte bei dir melden.`));
            await say(_t("Thank you so much for your patience!", "Vielen Dank für deine Geduld!"));
        } else {
            await say(_t("Got it! You can send your items in their original packaging to:<br><br>Lethal Cosmetics GmbH & Co. KG<br>Köpenicker Str. 325, Haus 12<br>12555 Berlin<br>Germany",
                "Verstanden! Du kannst die Artikel in ihrer Originalverpackung an:<br><br>Lethal Cosmetics GmbH & Co. KG<br>Köpenicker Str. 325, Haus 12<br>12555 Berlin<br>Deutschland<br><br>zurücksenden."));
            await say(_t(`Please write your order number <strong>#${order.id}</strong> legibly 😉 onto the shipping box.`,
                `Bitte schreibe die Bestellnummer <strong>#${order.id}</strong> gut sichtbar 😉 auf den Versandkarton.`));
            await say(_t(`And don't forget to sufficiently pre-pay the postage as we otherwise won't be able to receive your package.`,
                `Und denke bitte daran, die Sendung ausreichend zu frankieren, da wir un- bzw. unterfrankierte Sendungen nicht annehmen können.`));
        }
    }

    async function productQuestion() {
        await say(_t("Hi there! I'd be happy to answer <strong>any question about our products</strong> that you might have! 🤗",
            "Hi! Gerne beantworte ich deine <strong>Fragen zu unseren Produkten</strong>! 🤗"));
        await say(_t("Just type it in below!", "Du kannst sie einfach unten eingeben"));

        do {
            const question = await getUserEntry(false, false);

            let options;

            if (de) {
                options = [
                    [["vegan", "karmin", "tierische produkte", "bienenwachs"], "Unsere Produkte sind zu 100% vegan (PeTA-zertifiziert), d.h. sie enthalten keinerlei tierische Inhaltsstoffe! 🌱"],
                    [["halal", "حلال"], "Unsere Produkte sind halal حلال und von der World Halal Union zertifiziert!"],
                    [["cruelty-free", "tierversuch"], "Unsere Produkte und ihre Inhaltsstoffe sind zu 100% tierversuchsfrei (PeTA-zertifiziert)! 🐇"],
                    [["mica", "glimmer", "kinderarbeit"], "Alle unsere Produkte werden aus ethisch gewonnenen Rohstoffen hergestellt. Alle Informationen hierzu findest du auf der Seite <a href=\"/our-ethics\">unsere Werte</a>!"],
                    [["gluten"], "Alle unsere Produkte sind zu 100% glutenfrei. Das Vitamin E in unseren Produkten wird aus Sojaöl gewonnen und ist ebenfalls glutenfrei. 🌱"],
                    [["paraben"], "Unsere Produkte sind zu 100% Parabenfrei."],
                    [["talc"], "Keine unserer Produkte enthalten Talc."],
                    [["gmo", "genmanipuliert", "gentechnik"], "Unsere Produkte enthalten keine gentechnisch veränderten Rohstoffe."],
                    [["mikroplastik"], "Keines unserer Produkte enthält Mikroplastik."],
                    [["nano"], "Keines unserer Produkte enthält nanomaterial."],
                    [["pfa", "forever chemicals", "polyfluorinated"], "Unsere Produkte sind frei von jeglichen PFAS (forever chemicals)."]
                ];
            } else {
                options = [
                    [["vegan", "carmine", "animal product", "animal by product", "beeswax"], "All of our products are 100% PeTA-certified vegan, meaning they contain absolutely no animal products! 🌱"],
                    [["halal", "حلال"], "All of our products are halal حلال certified by the World Halal Union!"],
                    [["cruelty-free", "animal test"], "All of our products are 100% PeTA certified cruelty-free! 🐇"],
                    [["mica", "child labour", "child labor"], "All of our products are made from ethically sourced raw materials. You can find all about it on our <a href=\"/our-ethics\">Ethics</a> page!"],
                    [["gluten"], "All of our products are 100% gluten-free. The Vitamin E in our products is not sourced from wheat germ but from soy bean oil. 🌱"],
                    [["paraben"], "Our products are 100% paraben-free."],
                    [["talc"], "None of our products contain talc."],
                    [["gmo", "genetically modified"], "None of our products contain any GMO ingredients."],
                    [["microplastic"], "None of our products contain microplastics."],
                    [["nano"], "None of our products contain nano materials."],
                    [["pfa", "forever chemicals", "polyfluorinated"], "None of our products contain PFAS (forever chemicals) of any kind."]
                ];
            }

            let found = false;

            let lower = question.toLowerCase().replace("/[^a-z]/g", "");

            for (let option of options) {
                if (option[0].some(candidate => lower.includes(candidate))) {
                    await say(option[1]);
                    found = true;
                    break;
                }
            }

            if (found) {
                await say(_t("Did that answer your question? 🤔", "Beantwortet das deine Frage? 🤔"));

                if ((await choose({
                    caption: _t("No, that's not it", "Nicht wirklich"),
                    value: "no"
                }, {
                    caption: _t("Yes, thanks", "Ja, danke"),
                    value: "yes"
                })) === "no") {
                    await say(_t("Sorry about that! Best send your question to a human then!",
                        "Das tut mir leid! Dann sollten wir deinen Frage an einen Menschen weiterleiten!"));
                    await differentQuestion(false, true, question);
                    return;
                } else {
                    await say(_t("That's great!", "Perfekt!"));
                }
            } else {
                await say(_t("Ooops, I don't know how to answer that. Best send your question to a human then!",
                    "Ooops, darauf habe ich keine Antwort! Am besten leiten wir deine Frage an einen Menschen weiter!"));
                await differentQuestion(false, true, question);
                return;
            }

            await say(_t("Anything else you'd like to ask?", "Möchtest du noch etwas anderes wissen?"));

            if ((await choose({
                caption: _t("That's everything", "Das war's"),
                value: "no"
            }, {
                caption: _t("Yes, actually...", "Ja, und zwar..."),
                value: "yes"
            })) === "no") {
                break;
            }
        } while (true);
    }

    async function differentQuestion(showIntro = true, askForOrder = true, question = null) {
        let ticket = {
            type: "other"
        };

        if (showIntro) {
            await say(_t("Hi there! I'd be happy to <strong>forward your question to our customer service team</strong>! 🤗",
                "Hi! Gerne leite ich deine <strong>Frage an unseren Kundenservice</strong> weiter! 🤗"));
        }


        if (askForOrder) {
            await say(_t("Is your question related to an order of yours?",
                "Hat deine Frage etwas mit einer Bestellung von dir zu tun?"));

            if ((await choose({
                caption: _t("Nope", "Nein"),
                value: "no"
            }, {
                caption: _t("Yes, it is", "Ja, genau"),
                value: "yes"
            })) === "yes") {
                let order = await findOrder();
                ticket.order = order.id;
            }
        }

        if (askForOrder) {
            await say(_t("Great! What's your question?", "Alles klar! Wie lautet deine Frage?"));
        } else {
            await say(_t("Please enter your question below.", "Bitte gib unten deine Frage ein."));
        }

        await say(_t("P.S.: If you would like to include pictures with your question, you can upload them afterwards.",
            "P.S.: Wenn du deiner Frage auch Bilder beifügen möchtest, kannst du das gleich im Anschluss machen."));

        ticket.question = await getUserEntry(true, true, question);

        await say(_t("Would you like to attach any pictures to your message? 📷",
            "Möchtest du Bilder an deine Nachricht anhängen? 📷"));

        if ((await choose({
            caption: _t("No, thanks", "Nein, danke"),
            value: "no"
        }, {
            caption: _t("Yes, please", "Ja, bitte"),
            value: "yes"
        })) === "yes") {
            ticket.pictures = await askForImageUpload(5);
        }

        if (!ticket.order) {
            await say(_t("Last question: 🙈", "Letzte Frage: 🙈"));
            await say(_t("What email address can we use to get in touch with you?",
                "Unter welcher E-Mail-Adresse können wir dich erreichen?"));

            ticket.email = await choose({
                caption: _t("My email address is...", "Meine E-Mail-Adresse lautet..."),
                type: "input",
                placeholder: _t("e.g. name@example.com", "z.B. name@beispiel.de"),
                validator: value => /^.+?@.+?\..+?$/g.test(value.trim()) ? true :
                    _t("This does not look like an email address", "Das sieht nicht nach einer gültigen E-Mail Adresse aus")
            });
        }

        await submitTicket(ticket);

        await say(_t(`I've forwarded your information to Melanie on our customer service team who will <strong>email you in 1-2 business days</strong> with next steps.`,
            `Ich habe deine Nachricht an Melanie aus unserem Kundenservice-Team weitergeleitet. Sie wird dir innerhalb von <strong>1-2 Werktagen per E-Mail</strong> antworten.`));
        await say(_t("Thank you so much for your patience!", "Vielen Dank für deine Geduld!"));
    }

    let session;
    let submittedTranscript;

    async function updateSession() {
        if (!session || session.length < 1) {
            return;
        }

        let fullTranscript = getTranscript();
        let transcript = fullTranscript.substr(submittedTranscript.length);
        submittedTranscript = fullTranscript;

        await ajax("update_session", {
            uuid: session,
            transcript: transcript
        });
    }

    async function submitRating(rating) {
        if (!session || session.length < 1) {
            return;
        }

        await ajax("update_session", {
            uuid: session,
            rating: rating
        });
    }

    async function startSession(topic) {
        try {
            await wait(1000);
            const response = await ajax("start_session", {
                topic: topic
            });

            if (!response.success) {
                throw new Error();
            }

            submittedTranscript = "";

            return response.uuid;
        } catch (e) {
            await showMessageBox(_t("Oops, something went wrong. Please check your internet connection and try again.",
                "Ooops, das hat nicht geklappt. Bitte überprüfe deine Internetverbindung und versuche es erneut."));
            return null;
        }
    }

    function endSession() {
        session = null;
        submittedTranscript = "";
    }

    let chatEnded = true;

    async function startTopic(topic) {
        reset();
        await showStatus(_t("Sadie is joining the chat...", "Sadie tritt dem Chat bei..."), bot);

        session = await startSession(topic);

        if (!session) {
            closeChatWindow();
            return;
        }

        messageList.empty();

        await wait(200);
        await showStatus(_t("Sadie has joined the chat", "Sadie ist dem Chat beigetreten"), bot);
        lastDisplaySpeaker = null;

        switch (topic) {
            case "order-not-received":
                await orderNotReceived();
                break;
            case "cancel-order":
                await cancelOrder();
                break;
            case "collab":
                await collab();
                break;
            case "broken-item":
                await brokenItem();
                break;
            case "missing-item":
                await missingItem();
                break;
            case "technical-problem":
                await technicalProblem();
                break;
            case "return-item":
                await returnItem();
                break;
            case "product-question":
                await productQuestion();
                break;
            case "different-question":
                await differentQuestion();
                break;
            default:
                await say(_t("Oh no, something went wrong. Please try again at a later time.",
                    "Oh nein, da ist was schief gegangen. Bitte probiere es später erneut."));
                await indefinitely();
        }
        await askForFeedback();

        endSession();
    }


    $(".quick-help-overlay header button").click(() => {
       closeChatWindow();
    });

    $("div[data-topic]").click(async function () {
        openChatWindow();
        $(".quick-help-overlay > div > section > div").empty();
        await startTopic($(this).data("topic"));
    });

    const inputElement = $(".quick-help-overlay .entry textarea");
    const inputPlaceholderText = inputElement.val().trim();

    inputElement.on("focus", () => {
        const value = inputElement.val().trim();

        if (value === inputPlaceholderText) {
            inputElement.val("");
        }

        inputElement.removeClass("placeholder");
    });

    inputElement.on("blur", () => {
        const value = inputElement.val().trim();

        if (value.length < 1) {
            inputElement.val(inputPlaceholderText);
            inputElement.addClass("placeholder");
        }
    });

    inputElement.on("input", () => {
        const value = inputElement.val().trim();

        $(".quick-help-overlay .entry button").toggleClass("disabled", value.length < 1);
        inputElement.css("height", "5px").css("height", inputElement.get(0).scrollHeight + "px");
    });

    inputElement.on("keypress", e => {
        if (e.keyCode === 13 && !e.shiftKey) {
            e.preventDefault();
            $(".quick-help-overlay .entry").submit();
        }
    });

    $(".quick-help-overlay .entry").on("submit", e => {
        e.preventDefault();
        const message = inputElement.val().trim();

        inputElement.val("");


        const element = $(`<div class="message theirs"><div></div></div>`);
        element.find("div").text(sanitize(message));
        messageList.append(element);
        scrollChatWindowToBottom();

        if (entryCallback) {
            entryCallback(message);
        }
    });

    window.onbeforeunload = e => {
        if (!chatEnded) {
            e.returnValue = _t("If you leave the page, your chat will not be saved. Proceed anyway?",
                "Wenn du die Seite verlässt wird dein Chat nicht gespeichert. Trotzdem fortfahren?");
        }
    };
})();